const enLocale = {
    common: {
        Save: "Save",
        Send: "Send",
        Cancel: "Cancel",
        Delete: "Delete",
        Remove: "Remove",
        Add: "Add",
        Restore: "Restore",
        Retry: "Retry",
        Search: "Search",
        Reset: "Reset",
        Contract: "Contract",
        AddGuardian: "Add Guardian",
        Filter: "Filter",
        ApplyFilter: "Apply Filter",
        ClearFilters: "Clear Filters",
        From: "From",
        To: "To",
        Detail: "Detail",
        Objects: "Objects",
        Actions: "Actions",
        SelectOption: "Select an option",
        SearchByName: "Search by name or identity code",
        SearchByNameOrCode: "Search by name or code",
        SearchByNameAndCode: "Search by name and code",
        SearchByCode: "Search by code",
        BookingSystem: "Booking System",
        PageNotFound: "Page Not Found",
        PageNotFoundDescription: "The page you are looking for does not exist.",
        BackToDashboard: "Back to Dashboard",
        SearchByType: "Filter by type",
        SearchBySex: "Filter by sex",
        SearchByResidentType: "Filter by resident type",
        SearchByMunicipality: "Filter by municipality",
        SearchByDocumentType: "Filter by document type",
        People: "people",
        SearchByNotes: "Search by notes",
        SearchByDescription: "Search by description",
        SearchByMenu: "Search by menu content",
        FilterByStatus: "Filter by status",
        FilterByActive: "Filter by active",
        FilterByType: "Filter by type",
        FilterByUnitType: "Filter by unit type",
        FilterByPackageType: "Filter by package type",
        FilterByManufacturer: "Filter by manufacturer",
        FilterByMunicipality: "Filter by municipality",
        FilterByContractType: "Filter by contract type",
        ComingSoon: "Coming soon",
        FilterByLevel: "Filter by level",
        FilterByResident: "Filter by resident",
        SearchByContractId: "Search by contract ID",
        SelectContractType: "Select contract type",
        EnterContractId: "Enter contract ID",
        SelectResidentOrGuardian: "Select resident or guardian",
        ResidentOrGuardianRequired: "Please select a resident or guardian",
        SelectDocument: "Select document",
        SelectDocumentType: "Select document type",
        EnterVersion: "Enter version",
        EnterComments: "Enter comments",
        FirstName: "First Name",
        LastName: "Last Name",
        Phone: "Phone",
        PhoneNumber: "Phone Number",
        Email: "Email",
        FirstNameRequired: "First name is required",
        LastNameRequired: "Last name is required",
        PhoneRequired: "Phone number is required",
        EmailRequired: "Email address is required",
        InvalidEmail: "Please enter a valid email address",
        StartDateRequired: "Start date is required",
        EndDateOptional: "End date is optional",
        EndDateRequired: "End date is required",
        DateRangeRequired: "Date range is required",
        ContractTypeRequired: "Contract type is required",
        CalculationSetupRequired: "Calculation setup is required",
        DocumentRequired: "Document is required",
        Reason: "Reason",
        OptionalField: "Optional field",
        ReadOnlyField: "This field is read-only",
        Minutes: "minutes",
        Sunday: "Sunday",
        Monday: "Monday",
        Tuesday: "Tuesday",
        Wednesday: "Wednesday",
        Thursday: "Thursday",
        Friday: "Friday",
        Saturday: "Saturday",
        SelectDateTime: "Select date and time",
        MunicipalityNameRequired: "Municipality name is required",
        MunicipalityCodeRequired: "Municipality code is required",
        MunicipalitySupportRequired: "Municipality support is required",
        MonthlyPaymentRequired: "Monthly payment is required",
        Setup: "Setup",
        SelectCalculationSetup: "Select calculation setup",
        ManageCalculationSetups: "Manage calculation setups",
        MunicipalityName: "Municipality Name",
        MunicipalityCode: "Municipality Code",
        ContractType: "Contract Type",
        SupportedFormats: "Supported formats",
        Documents: "Documents",
        Document: "Document",
        StartDate: "Start Date",
        EndDate: "End Date",
        DateRange: "Date Range",
        NoEndDate: "No End Date",
        All: "All",
        Deleted: "Deleted",
        Searching: "Searching",
        RequiredFields: "Required fields",
        NoAddressesFound: "No addresses found",
        TypeAtLeast3Characters: "Please type at least 3 characters to search for an address",
        AddressNotFound: "Address not found",
        Forbidden: "Access forbidden",
        InsufficientPrivileges: "Insufficient privileges to access",
        BrushColor: "Brush Color",
        Active: "Active",
        Enabled: "Enabled",
        Refresh: "Refresh",
        Menu: "Menu",
        Yes: "Yes",
        No: "No",
        Name: "Name",
        Code: "Code",
        Description: "Description",
        Translations: "Translations",
        Translate: "Translate",
        ShowFilters: "Show Filters",
        HideFilters: "Hide Filters",
        Users: "Users",
        UserDetail: "User Details",
        AddUser: "Add User",
        Roles: "Roles",
        RoleDetail: "Role Details",
        AddRole: "Add Role",
        Municipalities: "Municipalities",
        MunicipalityDetail: "Municipality Details",
        AddMunicipality: "Add Municipality",
        AddTemplate: "Add Template",
        Generate: "Generate",
        GenerateDocument: "Generate Document",
        GenerateFromTemplate: "Generate from Template",
        DocumentTemplate: "Document Template",
        DocumentTemplateInfo: "Choose a document template to generate contracts from",
        SelectTemplateToGenerate: "Select a template to generate a new document",
        TemplateRequired: "Please select a document template",
        GenerateDocumentInfo: "Generate a new document from the selected template with contract data",
        DocumentGeneratedSuccessfully: "Document generated successfully",
        DocumentGenerationError: "Failed to generate document",
        GenerateDocumentError: "Error generating document",
        GenerateError: "Error generating contract and document",
        SelectDocumentTemplate: "Please select a document template first",
        ErrorLoadingData: "Error loading data",
        LoadingError: "Error loading data",
        SaveError: "Error saving data",
        DeleteError: "Error deleting data",
        RestoreError: "Error restoring data",
        RequiredFieldsError: "Please fill in the following required fields: {fields}",
        ChangeType: "Change Type",
        ChangedFields: "Changed Fields",
        NoFieldsChanged: "No fields changed",
        NoDataFound: "No data found",
        Success: "Success",
        Error: "Error",
        SaveSuccess: "Saved successfully",
        CreateSuccess: "Created successfully",
        UpdateSuccess: "Updated successfully",
        DeleteSuccess: "Deleted successfully",
        RestoreSuccess: "Restored successfully",
        Edit: "Edit",
        ConfirmDeletion: "Confirm Deletion",
        Confirm: "Confirm",
        Today: "Today",
        Clear: "Clear",
        Selected: "Selected",
        Close: "Close",
        FailedToLoadData: "Failed to load data",
        History: "History",
        User: "User",
        Employee: "Employee",
        CreatedOn: "Created On",
        CreatedBy: "Created By",
        ModifiedOn: "Modified On",
        ModifiedBy: "Modified By",
        Period: "Period",
        Type: "Type",
        View: "View",
        Resident: "Resident",
        ResidentFilter: "Resident",
        SearchForResident: "Search for resident...",
        SearchResidents: "Search residents...",
        NoResidentsFound: "No residents found",
        SelectDateRange: "Select date range",
        SelectDate: "Select date",
        ListView: "List View",
        Upload: "Upload",
        Create: "Create",
        Facility: "Facility",
        Date: "Date",
        Comments: "Comments",
        Note: "Note",
        Notes: "Service content",
        ServiceNotes: "Service content",
        Select: "Select",
        Quantity: "Quantity",
        FromDate: "From Date",
        ToDate: "To Date",
        FilterByArticle: "Filter by article",
        Template: {
            Language: "Language",
            Value: "Value"
        },
        UnsavedChanges: "Unsaved Changes",
        UnsavedChangesWarning: "You have unsaved changes. Are you sure you want to close without saving?",
        CloseWithoutSaving: "Close without saving",
        OpenInNewTab: "Open in new tab",
        Optional: "Optional",
        Room: "Room",
        SelectRoom: "Select room",
        ValidationError: "Validation Error",
        PleaseFillRequiredFields: "Please fill in all required fields",
        AllMunicipalities: "All Municipalities",
        Municipality: "Municipality",
        NotSet: "Not set",
        SelectAll: "Select All",
        SelectNone: "Select None",
        SelectMunicipality: "Select Municipality",
        MunicipalityRequired: "Municipality is required",
        MunicipalityLoadingError: "Error loading municipalities",
        ContractDetails: "Contract Details",
        Status: "Status",
        Days: "Days",
        ExportToExcel: "Export to Excel",
        Approve: "Approve",
        Approved: "Approved",
        Unapprove: "Unapprove",
        Go: "Go",
        SelectAction: "Select action",
        SelectedCount: "{count} selected",
        ClearSelection: "Clear Selection",
        Adjust: "Adjust",
        Balanced: "Balanced",
        Unbalanced: "Unbalanced",
        Manual: "Manual Entry",
        Calculated: "Calculated",
        Back: "Back",
        DecisionNumber: "Decision Number",
        DecisionNumberRequired: "Decision number is required",
        SelectMunicipalityContract: "Select Municipality Contract",
        MunicipalityContractRequired: "Municipality contract is required",
        SelectedContract: "Selected Contract",
        Previous: "Previous",
        Next: "Next",
        SelectServiceCalculationSetup: "Select Service Calculation Setup",
        ContractDocuments: "Contract Documents",
        IsActive: "Is Active",
        Inactive: "Inactive",
        JustNow: "Just now",
        MinutesAgo: "{minutes} minutes ago",
        HoursAgo: "{hours} hours ago",
        ViewDetails: "View Details",
        Service: "Service",
        Client: "Client",
        SelectClient: "Select client"
    },
    waitlist: {
        Waitlist: "Waitlist",
        SelectService: "Select Service",
        Priority: "Priority",
        Status: "Status",
        SubscribeClient: "Subscribe Client",
        ClientId: "Client ID",
        Notes: "Notes",
        Subscribe: "Subscribe",
        InvitesForSlot: "Invites for Slot",
        Sent: "Sent",
        Expires: "Expires",
        CreateInvite: "Create Invite",
        WaitlistId: "Waitlist ID",
        WindowMinutes: "Window (minutes)",
        SendInvite: "Send Invite",
        SubscriptionCreated: "Waitlist subscription created",
        EditSubscription: "Edit Waitlist Subscription",
        InvalidBookingId: "Invalid booking ID",
        InviteDataIncomplete: "Invite data is incomplete",
        InviteAccepted: "Invite accepted",
        InviteDeclined: "Invite declined",
        PleaseProvideWaitlistAndBookingId: "Please provide waitlist ID and booking ID",
        InviteSent: "Invite sent",
        BookingIdMissing: "Booking ID is missing"
    },
    menu: {
        Dashboard: "Dashboard",
        Bookings: "Bookings",
        Waitlist: "Waitlist",
        Clients: "Clients",
        Services: "Services",
        Employees: "Employees",
        Suggestions: "Suggestions",
        Notifications: "Notifications",
        Reports: "Reports",
        Rooms: "Rooms",
        Settings: "Settings",
        Residents: "Residents",
        Qualifications: "Qualifications",
        Documents: "Documents",
        Observations: "Observations",
        FoodMenu: "Food Menu",
        ScheduledActivity: "Scheduled activity",
        Accounting: "Accounting",
        Stock: "Stock",
        AddNew: "Add New",
        SaveSuccess: "Saved successfully",
        UnsavedChangesWarning: "You have unsaved changes. Are you sure you want to close without saving?",
        UnsavedChanges: "Unsaved Changes",
        CloseWithoutSaving: "Close without saving"
    },
    report: {
        ClientServiceVisitsTitle: "Client service visits report",
        ClientServiceHistoryTitle: "Client service history",
        BookingCancellationsTitle: "Booking cancellations",
        SelectServices: "Select services",
        SelectClient: "Select client or child",
        VisitDateRange: "Visit date range",
        NoData: "No report data found",
        ChildName: "Child name",
        ParticipantName: "Participant",
        VisitCount: "Visit count",
        CancellationCount: "Cancellation count",
        LastVisitDate: "Last visit",
        BookingStartTime: "Service start",
        BookingEndTime: "Service end",
        CancellationDate: "Date",
        CancellationTime: "Time",
        CancellationReason: "Cancellation reason",
        CancellationReasonMissing: "No reason provided",
        Duration: "Duration",
        ContractCode: "Contract code",
        AccountingCode: "Accounting code",
        TotalAmount: "Total amount",
        VisitAmount: "Visit amount",
        BookingNotes: "Service content",
        InternalComment: "Internal comment",
        BookingEmployee: "Employee",
        ExportExcel: "Export to Excel",
        OpenClientDetail: "Open client detail",
        OpenFullClientView: "Open full client view",
        ClientNotFound: "Client details were not found",
        LoadFailed: "Failed to load report",
        LoadClientFailed: "Failed to load client details",
        LoadServicesFailed: "Failed to load services"
    },
    residents: {
        Resident: "Resident",
        Residents: "Residents",
        ResidentsPlural: "residents",
        ResidentDetail: "Resident Detail",
        AddResident: "Add Resident",
        FirstName: "First Name",
        LastName: "Last Name",
        IdentityCode: "Identity Code",
        ResidentType: "Resident Type",
        Sex: "Sex",
        BirthDate: "Birth Date",
        Age: "Age",
        AgeCalculatedFromBirthDate: "Age is automatically calculated from birth date",
        Address: "Address",
        Municipality: "Municipality",
        PhoneNumber: "Phone Number",
        ResidentPhoneNumber: "Resident Phone Number",
        Guardians: "Guardians",
        GuardianFirstName: "Guardian First Name",
        GuardianLastName: "Guardian Last Name",
        GuardianEmail: "Guardian Email",
        GuardianPhone: "Guardian Phone",
        Relationship: "Relationship",
        ResidentHistory: "Resident History",
        ResidentHistoryDescription: "View all changes made to this resident",
        NoHistoryFound: "No history found for this resident",
        ResidentContracts: "Contracts",
    },
    residentContract: {
        Contracts: "Contracts",
        ResidentContracts: "Contracts",
        ContractNumber: "Contract Number",
        FacilityContracts: "Facility Contracts",
        MunicipalityContracts: "Municipality decisions",
        FacilityContract: "Facility Contract",
        MunicipalityContract: "Municipality decision",
        ContractType: "Contract Type",
        StartDate: "Start Date",
        EndDate: "End Date",
        ContactPerson: "Contact Person",
        Phone: "Phone",
        Email: "Email",
        Municipality: "Municipality",
        MunicipalitySupport: "Municipality Support",
        Pension: "Pension",
        Allowance: "Allowance",
        IsLiablePersonAvailable: "Liable Person Available",
        ExtraFinanceSupport: "Extra Finance Support",
        MunicipalityExtraFunding: "Municipality Extra Funding",
        SelectContract: "Select Contract",
        CurrentContract: "Current Contract",
        NoContractsFound: "No contracts found",
        ServiceCalculationSetup: "Service Calculation Setup",
        Document: "Document",
        Description: "Manage resident contracts including facility contracts and municipality contracts",
        AddContract: "Add Contract",
        EditContract: "Edit Contract",
        AddMunicipalityContract: "Add Municipality Contract",
        EditMunicipalityContract: "Edit Municipality Contract",
        DetailDialogComingSoon: "Contract detail form will be implemented in the next phase",
        MunicipalityDetailDialogComingSoon: "Municipality contract detail form will be implemented in the next phase",
        CreateSuccess: "Contract created successfully",
        UpdateSuccess: "Contract updated successfully",
        CreateResidentContract: "Create Resident Contract",
        Step1ChooseMunicipalityContract: "Choose Municipality Contract",
        Step2FillContractDetails: "Fill Contract Details",
        ChooseMunicipalityContract: "Choose Municipality Contract",
        MunicipalityContractDescription: "First, select an existing municipality contract or create a new one. This contract will be used as the basis for the resident contract.",
        FillContractDetails: "Fill Contract Details",
        ContractDetailsDescription: "Now fill in the specific details for this resident contract, including the resident/guardian, dates, and calculation setup.",
        ConfirmRestoreContract: "Are you sure you want to restore contract {contractName} #{contractNumber}?",
        ContractRestored: "Contract restored successfully",
        ResidentDeletedError: "Cannot restore contract: resident is deleted. Please restore the resident first.",
        // History
        ContractHistory: "Contract History",
        ViewHistory: "View History",
        ChangeType: "Change Type",
        ChangedFields: "Changed Fields"
    },
    residentContractBooking: {
        BookingPeriods: "Booking Periods",
        AddBooking: "Add Booking Period",
        EditBooking: "Edit Booking Period",
        BookingPercentage: "Booking Percentage",
        BookingPercentageInfo: "Percentage of normal rate to charge during booking period (e.g., 70% for reserved/booked periods)",
        BookingPercentageRequired: "Booking percentage is required",
        ReasonPlaceholder: "Enter reason for booking period (optional)",
        SaveSuccess: "Booking period saved successfully",
        OverlapWarning: "Date Range Overlap Detected",
        OverlapDetails: "This booking period overlaps with an existing booking. Please adjust the dates."
    },
    residentContractTimeOff: {
        TimeOffPeriods: "Time-Off Periods",
        AddTimeOff: "Add Time-Off Period",
        EditTimeOff: "Edit Time-Off Period",
        DailyRate: "Daily Rate",
        DailyRateInfo: "Fixed daily rate to charge during time-off period (e.g., 45€ per day)",
        DailyRateRequired: "Daily rate is required",
        ReasonPlaceholder: "Enter reason for time-off period (optional)",
        SaveSuccess: "Time-off period saved successfully",
        OverlapWarning: "Date Range Overlap Detected",
        OverlapDetails: "This time-off period overlaps with an existing time-off. Please adjust the dates."
    },
    residentMunicipalityContract: {
        AddContract: "Add Municipality Contract",
        EditContract: "Edit Municipality Contract",
        CreateSuccess: "Municipality contract created successfully",
        UpdateSuccess: "Municipality contract updated successfully",
        MonthlyPayment: "Monthly Payment",
        ExtraFinanceSupport: "Additional money from relatives",
        MunicipalityExtraFunding: "Total additional money from municipality (as stated in decision) excluding pocket money",
        ResidentOtherResponsibilitiesCost: "Resident Other Responsibilities Cost",
        MunicipalitySupport: "Municipality Support",
        Pension: "Pension",
        Allowance: "Pocket money",
        IsLiablePersonAvailable: "Is Liable Person Available",
        IsSpecialCalculation: "Special calculation (municipality)",
        IsSpecialCalculationHelp: "When enabled, uses the Excel 'special municipality' branch; AF/AG/AH totals are calculated accordingly for invoicing",
        ServiceFeeForFacility: "Care Cost (K)",
        ServiceFeeForFacilityHelp: "Monthly care cost fee for the facility (Excel column K)"
    },
    guardian: {
        Guardians: "Guardians",
        FirstName: "First Name",
        LastName: "Last Name",
        Phone: "Phone",
        Email: "Email",
        Address: "Address",
        IdentityCode: "Identity Code",
        Relationship: "Relationship",
        IsSendReport: "Send Report",
        AddGuardian: "Add Guardian",
        EditGuardian: "Edit Guardian",
        DeleteGuardian: "Delete Guardian",
        FirstNamePlaceholder: "Enter first name",
        LastNamePlaceholder: "Enter last name",
        PhonePlaceholder: "Enter phone number",
        EmailPlaceholder: "Enter email address",
        AddressPlaceholder: "Enter address",
        IdentityCodePlaceholder: "Enter identity code",
        SelectRelationship: "Select relationship",
        FirstNameRequired: "First name is required",
        LastNameRequired: "Last name is required",
        RelationshipRequired: "Relationship is required",
        DeleteConfirmation: "Are you sure you want to delete guardian {name}?",
        SaveSuccess: "Guardian saved successfully",
        DeleteSuccess: "Guardian deleted successfully",
    },
    settings: {
        General: "General",
        Users: "Users",
        Roles: "Roles",
        Lookups: "Lookups",
        Qualifications: "Qualifications",
        Services: "Services",
        ServicesManagement: "Services Management",
        UserManagement: "User Management",
        RoleManagement: "Role Management",
        Municipalities: "Municipalities",
        LookupTypeName: "Lookup Type Name",
        UserDetail: "User Detail",
        Username: "Username",
        Password: "Password",
        Email: "Email",
        FirstName: "First Name",
        LastName: "Last Name",
        RoleName: "Role Name",
        FacilityName: "Facility Name",
        Settings: "Settings",
        PublicHolidays: "Public Holidays",
        AddPublicHoliday: "Add Public Holiday",
        EditPublicHoliday: "Edit Public Holiday",
        HolidayDate: "Date",
        HolidayName: "Holiday",
        IsDayOff: "Day Off",
        SearchPublicHoliday: "Search by date or name",
        PublicHolidayHelp: "If a public holiday is marked as a day off, it will be shown in red on the calendar and employee availability badges will be hidden.",
        PublicHolidayCreated: "Public holiday created successfully",
        PublicHolidayUpdated: "Public holiday updated successfully",
        PublicHolidayDeleted: "Public holiday deleted successfully",
        PublicHolidayLoadFailed: "Failed to load public holidays",
        PublicHolidaySaveFailed: "Failed to save public holiday",
        User: {
            ColorFieldTooltip: "Select a color to identify this user in the system",
            UserRoles: "User Roles",
            UserFacilities: "User Facilities",
        }
    },
    roles: {
        RoleCode: "Role Code",
        RoleName: "Role Name",
        RoleDetail: "Role Detail",
        Privileges: "Privileges",
        PrivilegeName: "Privilege Name"
    },
    breadcrumb: {
        Home: "Home",
        Dashboard: "Dashboard",
        Residents: "Residents",
        ResidentDetail: "Resident detail",
        AddResident: "Add resident",
        Services: "Services",
        Bookings: "Bookings",
        Waitlist: "Waitlist",
        Qualifications: "Qualifications",
        Employees: "Employees",
        EmployeeDetail: "Employee detail",
        CreateEmployee: "Create employee",
        Clients: "Clients",
        ClientDetail: "Client detail",
        NewClient: "New client",
        MyProfile: "My Profile",
        Rooms: "Rooms",
        Settings: "Settings",
        Documents: "Documents",
        Stock: "Stock",
        Articles: "Articles",
        ArticleDetail: "Article detail",
        AddArticle: "Add article",
        UserDetail: "User detail",
        AddUser: "Add user",
        Lookups: "Lookups",
        LookupDetail: "Lookup detail",
        AddLookup: "Add lookup",
        Observations: "Observations",
        ObservationDetail: "Observation detail",
        AddObservation: "Add observation",
        FoodMenu: "Food Menu",
        EditFoodMenu: "Edit food menu",
        AddFoodMenu: "Add food menu",
    ScheduledActivities: "Scheduled activities",
    ScheduledActivityDetail: "Scheduled activity detail",
    AddScheduledActivity: "Add scheduled activity",
        Invoices: "Invoices",
        AddInvoice: "Add invoice",
        InvoiceDetail: "Invoice detail",
        CalculationDetail: "Calculation detail",
        StockLevels: "Stock levels",
        AddLevel: "Add level",
        LevelDetail: "Stock level detail",
        StockItems: "Stock items",
        AddItem: "Add item",
        ItemDetail: "Item detail",
        StockMovements: "Stock movements",
        AddMovement: "Add movement",
        Security: "Security",
        ActiveSessions: "Active Sessions",
        MySchedule: "My Schedule",
        MyAbsences: "My Absences",
        MyBookings: "My Bookings",
        MyPasses: "My Passes",
        ServicePasses: "Service Passes",
        Suggestions: "Suggestions",
        MySuggestions: "My Suggestions",
        Reports: "Reports",
        NotificationManagement: "Notification Management"
    },
    authentication: {
        Login: "Login",
        Logout: "Logout",
        Username: "Username",
        Password: "Password",
        Email: "Email",
        ForgotPassword: "Forgot Password?",
        ResetPassword: "Reset Password",
        NewPassword: "New Password",
        ConfirmPassword: "Confirm Password",
        LoginError: "Invalid username or password.",
        SessionExpired: "Your session has expired. Please log in again.",
        LoginSuccess: "Login successful!",
        LogoutSuccess: "Logout successful!",
        ChangePasswordSuccess: "Password changed successfully!",
        ForgotPasswordInstruction: "Enter your email address and we'll send you a link to reset your password.",
        EnterEmail: "Enter your email address",
        SendResetLink: "Send Reset Link",
        ResetEmailSent: "If an account with this email exists, a password reset link has been sent.",
        CheckYourEmail: "Please check your email for reset instructions",
        DidNotReceiveEmail: "If you don't see the email, check your spam folder or request a new link.",
        ResendEmail: "Send Again",
        ErrorSendingResetEmail: "Failed to send reset email. Please try again.",
        ResetEmailError: "Failed to send reset email. Please try again.",
        ResetPasswordInstruction: "Enter your new password below.",
        EnterNewPassword: "Enter new password",
        EnterConfirmPassword: "Confirm new password",
        ConfirmNewPassword: "Confirm new password",
        PasswordsDoNotMatch: "Passwords do not match",
        PasswordResetSuccess: "Password has been reset successfully! Redirecting to login...",
        PasswordResetSuccessful: "Password has been reset successfully!",
        PasswordResetError: "Failed to reset password. Please try again.",
        ErrorResettingPassword: "Failed to reset password. Please try again.",
        InvalidResetToken: "Invalid Reset Link",
        InvalidOrExpiredToken: "This reset link is invalid or has expired",
        RequestNewResetLink: "Please request a new password reset",
        RequestNewLink: "Request New Reset Link",
        InvalidResetTokenMessage: "This reset link is invalid or has expired. Please request a new password reset.",
        BackToLogin: "Back to Login",
        ValidatingToken: "Validating reset link...",
        TokenExpired: "This reset link has expired. Please request a new one.",
        TokenAlreadyUsed: "This reset link has already been used",
        PasswordRequirementsNotMet: "Password does not meet the requirements"
    },
    auth: {
        Username: "Username",
        UsernameOrEmail: "Username or Email",
        EnterUsernameOrEmail: "Enter your username or email",
        Password: "Password",
        Login: "Login",
        Logout: "Logout",
        LoggedOut: "You have been logged out",
        EnterUsername: "Enter your username",
        EnterPassword: "Enter your password",
        LoginFailed: "Login failed",
        LoginSuccessful: "Login successful",
        BookingSystemLogin: "Booking System Login",
        ContactAdminForAccess: "Contact administrator for access",
        InsufficientPrivileges: "Insufficient privileges",
        SessionExpired: "Your session has expired",
        Register: "Register",
        CreateYourAccount: "Create your account",
        Email: "Email",
        EnterEmail: "Enter your email",
        FirstName: "First Name",
        LastName: "Last Name",
        PhoneNumber: "Phone Number (Optional)",
        PreferredLanguage: "Preferred Language",
        SelectLanguage: "Select Language",
        EnterFirstName: "Enter your first name",
        EnterLastName: "Enter your last name",
        EnterPhoneNumber: "Enter your phone number",
        RegisterButton: "Create Account",
        PasswordRequirements: "Password must be at least 8 characters with uppercase, lowercase, digit, and special character (!@#$%^&*)",
        AlreadyHaveAccount: "Already have an account?",
        LoginHere: "Login here",
        DontHaveAccount: "Don't have an account?",
        RegisterHere: "Register here",
        VerifyEmail: "Verify Email",
        VerifyEmailDescription: "Enter the verification code sent to your email",
        VerificationToken: "Verification Token",
        EnterVerificationToken: "Enter verification token",
        TokenFromEmail: "Find this token in your email",
        VerifyButton: "Verify Account",
        VerificationSuccessful: "Email verified successfully! You can now log in.",
        VerificationFailed: "Email verification failed",
        VerifyingEmail: "Verifying your email...",
        GoToLogin: "Go to Login",
        DidntReceiveEmail: "Didn't receive the email?",
        ResendVerification: "Resend Verification Email",
        VerificationEmailResent: "Verification email has been resent. Please check your inbox.",
        RegistrationSuccessMessage: "Registration successful! Please check your email to verify your account.",
        RegistrationFailed: "Registration failed. Please try again.",
        InvalidEmail: "Please enter a valid email address",
        InvalidPhoneNumber: "Please enter a valid phone number",
        PasswordTooShort: "Password must be at least 8 characters",
        PasswordNeedsUppercase: "Password must contain at least one uppercase letter",
        PasswordNeedsLowercase: "Password must contain at least one lowercase letter",
        PasswordNeedsNumber: "Password must contain at least one number",
        PasswordNeedsSpecialChar: "Password must contain at least one special character (!@#$%^&*)",
        FirstNameRequired: "First name is required",
        LastNameRequired: "Last name is required",
        EmailRequired: "Email is required",
        EmailAndTokenRequired: "Email and token are required",
        ResendFailed: "Failed to resend verification email",
        Registration_InvalidEmail: "Please enter a valid email address",
        Registration_EmailAlreadyExists: "This email address is already in use. Please use a different email or try logging in.",
        Registration_PasswordRequired: "Password is required",
        Registration_PasswordTooShort: "Password must be at least 8 characters",
        Registration_PasswordNeedsUppercase: "Password must contain at least one uppercase letter",
        Registration_PasswordNeedsLowercase: "Password must contain at least one lowercase letter",
        Registration_PasswordNeedsNumber: "Password must contain at least one digit",
        Registration_PasswordNeedsSpecialChar: "Password must contain at least one special character",
        Registration_SystemError: "System error. Please try again later.",
        Registration_Successful: "Registration successful! Check your email for verification.",
        Verification_InvalidToken: "Invalid verification token",
        Verification_TokenExpired: "Your verification link has expired. Please click 'Resend Verification Email' to get a new link.",
        Verification_TokenAlreadyUsed: "Your email has already been verified. You can now log in to your account.",
        Verification_UserNotFound: "User not found",
        Verification_SystemError: "System error. Please try again later.",
        Verification_Successful: "Email verified successfully!",
        Verification_AlreadyVerified: "Email is already verified",
        Verification_EmailResent: "Verification email has been resent",
        TooManyAttempts: "Too many registration attempts. Please try again later.",
        ForgotPassword: "Forgot Password?",
        ForgotPasswordInstruction: "Enter your email address and we'll send you a link to reset your password.",
        BackToLogin: "Back to Login",
        SendResetLink: "Send Reset Link"
    },
    deleteDialog: {
        Header: "Confirm Delete",
        DeleteMessage: "Are you sure you want to delete {objectName}?",
        Delete: "Delete",
        Cancel: "Cancel",
        DeletedSuccessfully: "{objectName} has been deleted successfully!"
    },
    toast: {
        UserCreated: "User has been created successfully!",
        UserUpdated: "User has been updated successfully!",
        UserDeleted: "User has been deleted successfully!",
        FailedToSaveUser: "Failed to save user!",
        FailedToDeleteUser: "Failed to delete user!",
        FailedToLoadUsers: "Failed to load users!",
        RoleCreated: "Role has been created successfully!",
        RoleUpdated: "Role has been updated successfully!",
        RoleDeleted: "Role has been deleted successfully!",
        FailedToSaveRole: "Failed to save role!",
        FailedToDeleteRole: "Failed to delete role!",
        FailedToLoadRoles: "Failed to load roles!",
        FailedToLoadPrivileges: "Failed to load privileges!",
        RoleCodeAndNameRequired: "Role code and name are required!"
    },
    lookup: {
        Name: "Name",
        Code: "Code",
        Type: "Type",
        LookupDetail: "Lookup Detail",
        AddLookup: "Add Lookup",
        EditLookup: "Edit Lookup",
        LoadError: "Failed to load lookups"
    },
    municipality: {
        Municipality: "Municipality",
        MunicipalityDetail: "Municipality Detail",
        AddMunicipality: "Add Municipality",
        EditMunicipality: "Edit Municipality",
        MunicipalityName: "Municipality Name",
        MunicipalityCode: "Municipality Code",
        ParentMunicipality: "Parent Municipality",
        ShowMoveChildrenTo: "Move child municipalities to another municipality",
        DeleteMunicipality: "Delete Municipality",
        MoveTo: "Move to",
        ConfirmDelete: "Are you sure you want to delete this municipality?",
        CannotDeleteWithChildren: "Cannot delete municipality with child municipalities. Please move or delete child municipalities first.",
        MunicipalityCreated: "Municipality created successfully",
        MunicipalityUpdated: "Municipality updated successfully",
        MunicipalityDeleted: "Municipality deleted successfully"
    },
    document: {
        Documents: "Documents",
        Templates: "Templates",
        DownloadHistory: "Download History",
        NoDownloadHistory: "No download history found",
        Name: "Document Name",
        Code: "Document Code",
        DocumentType: "Document Type",
        FilterByDocumentType: "Filter by document type",
        File: "File",
        CreateDocument: "Create Document",
        EditDocument: "Edit Document",
        CreateTemplate: "Create Template",
        EditTemplate: "Edit Template",
        AddTemplate: "Add Template",
        SelectDocumentType: "Select document type",
        TemplateDocumentTypeInfo: "Templates are automatically set to Template document type",
        AvailablePlaceholders: "Available Placeholders",
        PlaceholderUsageInfo: "Use these placeholders in your template files. They will be automatically replaced with actual values when generating documents.",
        // Placeholder descriptions
        PlaceholderFirstName: "Resident first name",
        PlaceholderLastName: "Resident last name",
        PlaceholderPersonalCode: "Personal identification code",
        PlaceholderBirthDate: "Date of birth",
        PlaceholderContractNumber: "Contract number",
        PlaceholderContractStartDate: "Contract start date",
        PlaceholderContractEndDate: "Contract end date",
        PlaceholderFacilityName: "Facility name",
        PlaceholderMunicipalityName: "Municipality name",
        PlaceholderMunicipalityDecisionNr: "Municipality decision number",
        PlaceholderGuardianName: "Guardian name",
        PlaceholderGuardianPhone: "Guardian phone number",
        PlaceholderGuardianEmail: "Guardian email address",
        PlaceholderResidentAddress: "Resident address",
        PlaceholderServiceType: "Service type",
        PlaceholderMonthlyCost: "Monthly service cost",
        PlaceholderCreatedDate: "Contract creation date",
        PlaceholderCreatedBy: "Contract created by",
        ChooseFile: "Choose File",
        ReplaceFile: "Replace File",
        SelectedFile: "Selected file",
        CurrentFileInfo: "Current file - click download to save or delete to remove",
        DownloadFile: "Download file",
        DeleteFile: "Delete file",
        FileMarkedForDeletion: "File marked for deletion. Upload a new file or it will be removed when saving.",
        LoadError: "Failed to load document",
        SaveError: "Failed to save document",
        SaveSuccess: "Document saved successfully",
        DeleteSuccess: "Document deleted successfully",
        DeleteError: "Failed to delete document",
        ConfirmDelete: "Are you sure you want to delete '{name}'?",
        Download: "Download",
        DownloadStarted: "Download started",
        DownloadError: "Failed to download document"
    },
    medicalInformation: {
        BasicInformation: "Basic Information",
        MedicalConditions: "Medical Conditions",
        Mobility: "Mobility",
        MobilityDescription: "Mobility Description",
        HealthStatusNotes: "Health Status Notes",
        InfectiousDiseaseNotes: "Infectious Disease Notes",
        IsSmoker: "Smoker",
        IsAlcoholic: "Alcoholic",
        IsDementia: "Dementia",
        IsViolent: "Violent",
        IsDigestionProblem: "Digestion Problem",
        IsDiabetes: "Diabetes",
        IsMentalDisorder: "Mental Disorder",
        IsSpeechImpairment: "Speech Impairment",
        IsHearingImpairment: "Hearing Impairment",
        IsMRSA: "MRSA",
        IsDialysis: "Dialysis",
        IsESBL: "ESBL",
        IsTuberculosis: "Tuberculosis",
        SaveSuccess: "Medical information saved successfully",
        LoadError: "Failed to load medical information",
        SaveError: "Failed to save medical information"
    },
    observation: {
        Observations: "Observations",
        Observation: "Observation",
        ObservationType: "Observation Type",
        ObservationId: "Observation ID",
        Notes: "Notes",
        ObservationDetails: "Observation Details",
        AddObservation: "Add Observation",
        EditObservation: "Edit Observation",
        SelectObservationType: "Select observation type",
        SelectResident: "Select Resident",
        NotesPlaceholder: "Enter observation notes...",
        ObservationTypeRequired: "Observation type is required",
        NotesRequired: "Notes are required",
        ResidentRequired: "Resident selection is required",
        CreateSuccess: "Observation created successfully",
        UpdateSuccess: "Observation updated successfully",
        SaveError: "Failed to save observation",
        LoadError: "Failed to load observation",
        DeleteError: "Failed to delete observation",
        NoObservationsFound: "No observations found",
        AddFirstObservation: "Add First Observation",
        types: {
            General: "General",
            Medical: "Medical",
            Behavioral: "Behavioral",
            Care: "Care"
        }
    },
    foodMenu: {
        FoodMenu: "Food Menu",
        FoodMenus: "Food Menus",
        AddFoodMenu: "Add Food Menu",
        EditFoodMenu: "Edit Food Menu",
        FoodMenuDetails: "Food Menu Details",
        BasicInformation: "Basic Information",
        MenuDetails: "Menu Details",
        Menu: "Menu",
        NutritionalInformation: "Nutritional Information",
        MenuDate: "Menu Date",
        MenuPlaceholder: "Enter menu items for this date...",
        NutritionalInfoPlaceholder: "Enter nutritional information (calories, allergens, etc.)...",
        SelectDateRangeToStart: "Select a date range to start creating menus",
        SelectDateRange: "Select Date Range",
        LoadError: "Failed to load food menus",
        SaveError: "Failed to save food menu",
        DeleteError: "Failed to delete food menu",
        CreateSuccess: "Food menu created successfully",
        UpdateSuccess: "Food menu updated successfully",
        DeleteSuccess: "Food menu deleted successfully",
        SelectResidents: "Select Residents",
        AllResidentsSelected: "All residents selected",
        NoFoodMenusFound: "No food menus found",
        AddFirstFoodMenu: "Add First Food Menu",
        MenuRequired: "Menu is required",
        MenuDateRequired: "Menu date is required",
        ResidentsRequired: "At least one resident must be selected",
        StartDateRequired: "Start date is required",
        EndDateRequired: "End date is required",
        EndDateMustBeAfterStartDate: "End date must be after start date",
        SelectAtLeastOneResident: "Please select at least one resident",
        NoMenuDatesToSave: "No menu dates to save",
        AllMenusMustBeFilled: "All menu fields must be filled out",
        DateRange: "Date Range",
        StartDate: "Start Date",
        EndDate: "End Date"
    },
    scheduledActivity: {
        ScheduledActivities: "Scheduled Activities",
        ScheduledActivity: "Scheduled Activity",
        ActivityType: "Activity Type",
        Description: "Description",
        When: "When",
        Resident: "Resident",
        AddScheduledActivity: "Add Scheduled Activity",
        EditScheduledActivity: "Edit Scheduled Activity",
        SelectActivityType: "Select activity type",
        SelectResident: "Select resident",
        DescriptionPlaceholder: "Enter activity description...",
        ActivityTypeRequired: "Activity type is required",
        DescriptionRequired: "Description is required",
        ResidentRequired: "Resident selection is required",
        CreateSuccess: "Scheduled activity created successfully",
        UpdateSuccess: "Scheduled activity updated successfully",
        SaveError: "Failed to save scheduled activity",
        LoadError: "Failed to load scheduled activity",
        DeleteError: "Failed to delete scheduled activity",
        NoItemsFound: "No scheduled activities found",
        AddFirstItem: "Add First Scheduled Activity"
    },
    invoice: {
        Invoices: "Invoices",
        InvoiceDetail: "Invoice Detail",
        AddInvoice: "Add Invoice",
        EditInvoice: "Edit Invoice",
        InvoiceDetails: "Invoice Details",
        SearchByNumber: "Search by invoice number",
        number: "Invoice Number",
        numberPlaceholder: "Enter invoice number",
        resident: "Resident",
        selectResident: "Select resident",
        type: "Invoice Type",
        selectType: "Select invoice type",
        startDate: "Start Date",
        selectDate: "Select date",
        dueDate: "Due Date",
        selectDueDate: "Select due date",
        amount: "Amount",
        amountPlaceholder: "Enter amount",
        vatIncluded: "VAT Included",
        vatIncludedLabel: "VAT is included in amount",
        document: "File",
        uploadDocument: "Choose File",
        viewDocument: "View File",
        InvoiceDocument: "Invoice File",
        NoDocumentSelected: "No file selected",
        Number: "Invoice Number",
        StartDate: "Start Date",
        DueDate: "Due Date",
        InvoiceType: "Invoice Type",
        Amount: "Amount",
        IsVATIncluded: "VAT Included",
        Document: "Document",
        CalculationSetup: "Calculation Setup",
        Setup: "Setup",
        SetupDescription: "Manage calculation setups and service calculation setups for invoice calculations.",
        ServiceCalculationSetupDescription: "Configure service fees, base rates, and billing periods for different services.",
        CalculationSetupDescription: "Configure Excel constants and municipality support rates for invoice calculations.",
        ManageServiceCalculationSetups: "Manage Service Calculation Setups",
        ManageCalculationSetups: "Manage Calculation Setups",
        Download: "Download",
        NumberRequired: "Invoice number is required",
        StartDateRequired: "Start date is required",
        DueDateRequired: "Due date is required",
        InvoiceTypeRequired: "Invoice type is required",
        AmountRequired: "Amount must be greater than 0",
        ResidentRequired: "Resident is required",
        DocumentRequired: "Document is required",
        DueDateMustBeAfterStartDate: "Due date must be greater than or equal to start date",
        InvoiceCreated: "Invoice created successfully",
        InvoiceUpdated: "Invoice updated successfully",
        SaveError: "Failed to save invoice",
        LoadError: "Failed to load invoice",
        DeleteError: "Failed to delete invoice",
        DownloadError: "Failed to download invoice",
        DownloadNotImplemented: "Download feature not yet implemented",
        CalculationSetupNotImplemented: "Calculation setup not yet implemented",
        UploadNotImplemented: "Upload feature not yet implemented",
        NoInvoicesFound: "No invoices found",
        AddFirstInvoice: "Add First Invoice",
        SelectInvoiceType: "Select Invoice Type"
    },
            invoiceCalculation: {
            CalculationDetail: "Calculation Detail",
            CalculatedValues: "Calculated Values",
            StockCostBreakdown: "Stock Cost Breakdown",
            StockItemsUsed: "Stock Items Used in Calculation",
            NoStockItems: "No stock items were included in this calculation",
            TotalStockCost: "Total Stock Cost",
            Article: "Article",
            Units: "Units",
            CostPerUnit: "Cost Per Unit",
            TotalCost: "Total Cost",
            MovementDate: "Movement Date",
            MovementType: "Movement Type",
            StockLevel: "Stock Level",
            Calculations: "Calculations",
        InvoiceCalculationWorkflow: "Invoice Calculation Workflow",
        WorkflowDescription: "Create and manage bulk invoice calculations for residents",
        Step1Setup: "Setup Calculation Parameters",
        Step2Selection: "Select Residents",
        Step3Calculation: "Calculate & Review",
        Step4Actions: "Final Actions",
        Step1Description: "Configure calculation parameters and select setup",
        Step2Description: "Select residents and enter manual data",
        Step3Description: "Review calculation results and approve",
        Step4Description: "Final actions and workflow completion",
        CalculationPeriod: "Calculation Period",
        SelectPeriod: "Select calculation period",
        CalculationSetup: "Calculation Setup",
        SelectSetup: "Select calculation setup",
        SetupRequiredFields: "Please select calculation setup and period to continue",
        ProceedToSelection: "Proceed to Selection",
        ResidentsSelected: "Residents Selected: {count}",
        ProceedToCalculation: "Proceed to Calculation",
        CalculatingInProgress: "Calculating in Progress",
        ProcessingCalculations: "Processing calculations...",
        RecalculateAll: "Recalculate All",
        ProceedToActions: "Proceed to Actions",
        CalculationResults: "Calculation Results",
        CalculationResultsDescription: "Review and approve calculation results",
        TotalCalculations: "Total Calculations: {count}",
        ApprovedCalculations: "Approved: {count}",
        TotalAmount: "Total Amount: {amount}",
        TotalAmountSum: "Total Amount: {amount}",
        SpecialCalculations: "Special Municipality: {count}",
        AverageAmount: "Average Amount: {amount}",
        ApproveAllCalculations: "Approve All Calculations",
        GenerateInvoices: "Generate Invoices",
        ExportToExcel: "Export to Excel",
        StartNewWorkflow: "Start New Workflow",
        SelectResidents: "Select Residents for Calculation",
        SelectResidentsDescription: "Choose residents to include in bulk calculation",
        SelectByMunicipality: "Select by Municipality",
        ExcelCalculationBreakdown: "Calculation Breakdown",
        AllColumnsEtoAR: "All calculation columns",
        MaintenanceObligated: "Liable Person",
        CalculationType: "Calculation Type",
        ServicePeriodStartDate: "Service Start",
        ServicePeriodEndDate: "Service End",
        DaysOfMonth: "Days",
        NursingHomeCareComponent: "Nursing Home Care Component",
        ServiceFeePerDay: "Care Cost Per Day",
        FinalExtraCost: "Extra Cost",
        MunicipalityLimit: "Municipality Limit",
        ResidentBrutoIncome: "Gross Income",
        ResidentAllowence: "Allowance",
        ResidentOtherResponsibilitiesCost: "Other Costs",
        BookingDays: "Booking Days",
        TimeOffDays: "Time Off Days",
        AverageOldAgePension: "Average Old-Age Pension",
        ResidentTotalInMonth: "Resident Total in Month",
        ThirdPartyTotalInMonth: "Third Party Total in Month",
        MunicipalityTotalObligations: "Municipality Total Obligations in Month",
        ExcelE: "Liable Person Exists",
        ExcelF: "Calculation Type",
        ExcelG: "Service Period Start",
        ExcelH: "Service Period End",
        ExcelI: "Days of Month",
        ExcelJ: "Service Fee Per Month",
        ExcelK: "Care Cost",
        ExcelL: "Extra Cost",
        ExcelN: "Municipality Support",
        ExcelO: "Service Fee (if > Support)",
        ExcelP: "Other Cost",
        ExcelQ: "Resident Income",
        ExcelS: "Resident Gross Income",
        ExcelT: "Resident Allowance",
        ExcelU: "Resident Other Responsibilities",
        ExcelV: "Resident Cost Before Support",
        ExcelW: "Resident Keep Allowance",
        ExcelZ: "Additional Money Needed",
        ExcelAA: "Lower Income Compensation",
        ExcelAB: "Max Maintenance Cost (Tallinn)",
        ExcelAE: "Additional Compensation for Dependents",
        ExcelAF: "Resident Total Per Month",
        ExcelAG: "Third Party Total Per Month",
        ExcelAH: "Municipality Total Obligations Summary",
        ExcelAQ: "Total Bill Without Allowance",
        ExcelAR: "Control Column",
        Special: "Special",
        Standard: "Standard",
        ViewBreakdown: "View Breakdown",
        ResidentTotal: "Resident Total",
        ThirdParty: "Third Party",
        Municipality: "Municipality",
        TotalBill: "Total Bill",
        Recalculate: "Recalculate",
        NoCalculationsYet: "No calculations yet",
        SelectResidentsToCalculate: "Select residents to start calculating",
        LoadingSetupsError: "Error loading calculation setups",
        CalculationsCompleted: "Calculations completed successfully",
        CalculationsPartiallyCompleted: "Calculations partially completed",
        NoCalculationsCompleted: "No calculations completed",
        NoCalculationsToExport: "No calculations to export",
        NoCalculationLoaded: "No calculation loaded",
        ExcelExportSuccess: "Calculations exported to Excel successfully",
        CalculationError: "Error during calculation",
        RecalculationError: "Error during recalculation",
        ApprovalSuccess: "Calculations approved successfully",
        UnapprovalSuccess: "Calculations unapproved successfully",
        ApprovalError: "Error approving calculations",
        InvoiceGenerationNotImplemented: "Invoice generation not yet implemented",
        ExcelExportNotImplemented: "Excel export not yet implemented",
        WorkflowReset: "Workflow has been reset",
        CalculationBreakdown: "Calculation Breakdown",
        BreakdownIntro: "Detailed view of how each field was calculated, mirroring the Excel columns.",
    ExtraCost: "Extra Cost",
    ServiceFeeForFacility: "Care Cost (K)",
    CareCostHelp: "Care cost for the period (Excel K). Comes from the service calculation setup and can be adjusted if needed.",
    CareCostFromContract: "Care cost is configured in the resident's municipality contract",
    NotSet: "Not set",
    PlaceFeeOverride: "Monthly Place Fee (J) Override",
    PlaceFeeOverrideHelp: "Optional override for Monthly Place Fee (Excel J). Leave empty to use the value from the calculation setup.",
        OtherResponsibilities: "Other Responsibilities",
        LessDaysComment: "Less Days Comment",
        LessDaysCommentPlaceholder: "Enter comment for reduced days...",
        GeneralComment: "General Comment",
        GeneralCommentPlaceholder: "Enter general comment...",
        ReadyForCalculation: "Ready for Calculation",
        MissingRequiredData: "Missing Required Data",
        ValidationIssues: "Validation Issues",
        NoResidentsSelected: "No residents selected",
        IncompleteResidents: "{count} residents have incomplete data",
        ResidentsProcessed: "Residents Processed",
        CalculatedValue: "Calculated",
        Calculated: "Calculated",
        EditExtraCost: "Edit Extra Cost",
        CalculatedStockCost: "Calculated Stock Cost",
        AutomaticStockCalculation: "Automatically calculated from stock movements in the selected period",
        ManualOverride: "Manual Override",
        EnterManualOverride: "Enter manual override amount...",
        ManualOverrideDescription: "Leave empty to use the calculated stock cost value",
        EffectiveValue: "Effective Value",
        UsingManualOverride: "Using manual override value",
        UsingCalculatedValue: "Using calculated stock cost",
        ClearOverride: "Clear Override",
        ExtraCostUpdated: "Extra cost updated successfully",
        ExtraCostUpdateError: "Error updating extra cost",
        AdjustExtraCost: "Adjust Extra Cost",
        AdjustmentAmount: "Adjustment Amount",
        EnterAdjustmentAmount: "Enter adjustment amount (positive or negative)...",
        AdjustmentAmountHelp: "Positive values add cost, negative values provide discount. Zero or empty clears adjustment.",
        AdjustmentNote: "Adjustment Note",
        EnterAdjustmentNote: "Enter reason for adjustment (required)...",
        CalculatedCost: "Calculated Stock Cost",
        Adjustment: "Adjustment",
        FinalCost: "Final Extra Cost",
        AdjustmentSaved: "Adjustment saved successfully",
        AdjustmentSaveError: "Error saving adjustment",
        AdjustedBy: "Adjusted By",
        AdjustedAt: "Adjusted At",
        AdjustmentApplied: "Adjustment has been applied to the calculation",
        // New keys for Calculation List View
        CalculationHistory: "Calculation History",
        CreateNewCalculation: "Create New Calculation",
        ApprovedLocked: "Approved (Locked)",
        NotApproved: "Not Approved",
        Approved: "Approved",
        ViewCalculation: "View Calculation",
        DeleteCalculation: "Delete Calculation",
        ConfirmDeleteCalculation: "Are you sure you want to delete this calculation?",
        DeleteCalculationSuccess: "Calculation deleted successfully",
        DeleteCalculationError: "Failed to delete calculation",
        // Stock Movement Conflict Detection
        StockMovementConflictDetected: "Conflict with another invoice calculation",
        ConflictWarning: "This calculation uses stock movements that are already assigned to another approved calculation.",
        ConflictDescription: "{count} stock movement(s) conflict with approved calculation(s): {calculationIds}",
        ConflictDescriptionShort: "{count} stock movement(s) conflict with approved calculation(s)",
        MustRecalculate: "You must recalculate this calculation to resolve conflicts before approving.",
        ConflictedMovements: "Conflicted Stock Movements",
        ConflictingCalculations: "Conflicting Calculations",
        RecalculateToResolve: "Recalculate to Resolve",
        CannotApproveWithConflicts: "Cannot approve calculation with stock movement conflicts",
        RecalculateSuccess: "Calculation recalculated successfully",
        RecalculateFailed: "Failed to recalculate calculation",
        ApproveSuccess: "Calculation approved successfully",
        ApproveFailed: "Failed to approve calculation",
        UnapproveSuccess: "Calculation unapproved successfully",
        UnapproveFailed: "Failed to unapprove calculation",
        CalculationCreatedSuccess: "Calculation created successfully",
        Calculation: "Calculation",
        PeriodStart: "Period Start",
        PeriodEnd: "Period End",
        BulkRecalculate: "Recalculate",
        BulkDelete: "Delete",
        BulkApprove: "Approve",
        BulkExport: "Export to Excel",
        BulkRecalculateSuccess: "{count} calculation(s) recalculated successfully",
        BulkRecalculateFailed: "Failed to recalculate calculations",
        BulkDeleteSuccess: "{count} calculation(s) deleted successfully",
        BulkDeleteFailed: "Failed to delete calculations",
        BulkDeleteConfirm: "Are you sure you want to delete {count} calculation(s)?",
        BulkDeleteApprovedWarning: "Cannot delete approved calculations. {count} approved calculation(s) will be skipped.",
        BulkApproveSuccess: "{successCount} calculation(s) approved successfully",
        BulkApprovePartial: "{successCount} approved, {failedCount} failed due to conflicts or other errors",
        BulkApprovePartialFail: "{success} approved, {failed} failed due to conflicts or other errors",
        BulkApproveFailed: "Failed to approve calculations",
        SomeApprovedSkipped: "Some approved calculations were skipped",
        SomeAlreadyApprovedSkipped: "Some calculations are already approved and were skipped",
        AllAlreadyApproved: "All selected calculations are already approved",
        BulkExportSuccess: "Excel file generated successfully",
        BulkExportFailed: "Failed to generate Excel file",
        BulkExportNotImplemented: "Excel export feature is not yet implemented. This feature requires installing the Excel generation library.",
        SelectedCalculations: "{count} calculation(s) selected",
        DuplicateSelectionWarning: "Duplicate calculation for same resident and period",
        CannotApproveDuplicates: "Cannot approve: duplicate calculations selected for same resident and period",
        ApprovedCalculationWarning: "Approved calculation cannot be recalculated",
        CannotRecalculateApproved: "Cannot recalculate: approved calculations selected",
        CannotDeleteApproved: "Cannot delete: approved calculations selected"
    },
    calculationSetup: {
        CalculationSetups: "Calculation Setups",
        ManageCalculationSetups: "Manage Calculation Setups",
        ManageSetups: "Manage Setups",
        CreateSetup: "Create Calculation Setup",
        EditSetup: "Edit Calculation Setup",
        BasicInformation: "Basic Information",
        ExcelConstants: "Excel Constants (From Excel References)",
        NamePlaceholder: "Enter setup name (e.g., Summer 2024 Rates)",
        DescriptionPlaceholder: "Enter description (optional)",
        MunicipalitySupportPerResident: "Municipality Support per Resident",
        Support1: "Support Level 1 ($I$7)",
        Support2: "Support Level 2 ($I$8)",
        Support3: "Support Level 3 ($I$9)",
        Preview: "Preview",
        MunicipalitySupport: "Municipality Support",
        Constants: "Constants",
        UsageCount: "Usage Count",
        Duplicate: "Duplicate",
        SearchByName: "Search calculation setups by name",
        NameRequired: "Name is required",
        ReportPeriodRequired: "Report period days is required",
        Support1Required: "Support level 1 is required",
        Support2Required: "Support level 2 is required",
        Support3Required: "Support level 3 is required",
        CreatedSuccessfully: "Calculation setup created successfully",
        UpdatedSuccessfully: "Calculation setup updated successfully",
        DuplicatedSuccessfully: "Calculation setup duplicated successfully",
        CreateError: "Error creating calculation setup",
        UpdateError: "Error updating calculation setup",
        DuplicationError: "Error duplicating calculation setup",
        DeleteError: "Error deleting calculation setup",
        LoadingError: "Error loading calculation setups",
        DuplicateSetup: "Duplicate Setup",
        DuplicateSetupDescription: "Create a copy of this setup with a new name",
        DuplicateNameSuffix: "Copy",
        DuplicateNamePlaceholder: "Enter new name for duplicated setup",
        DuplicateNameRequired: "Duplicate name is required"
    },
    serviceCalculationSetup: {
        ServiceCalculationSetups: "Service Calculation Setups",
        ManageServiceCalculationSetups: "Manage Service Calculation Setups",
        CreateServiceCalculationSetup: "Create Service Calculation Setup",
        EditServiceCalculationSetup: "Edit Service Calculation Setup",
        BaseFee: "Base Fee",
        Period: "Period",
        SelectPeriod: "Select Period",
        BookingPercentage: "Booking Percentage",
        TimeOffDailyRate: "Time-Off Daily Rate",
        SearchByName: "Search by name",
        SearchByCode: "Search by code",
        NameRequired: "Name is required",
        CodeRequired: "Code is required",
        BaseFeeRequired: "Base fee is required",
        PeriodRequired: "Period is required"
    },
    residentContractDocument: {
        ContractDocuments: "Contract Documents",
        CreateContractDocument: "Create Contract Document",
        EditContractDocument: "Edit Contract Document",
        ContractType: "Contract Type",
        ContractId: "Contract ID",
        Document: "Document",
        DocumentType: "Document Type",
        IsActive: "Is Active",
        Version: "Version",
        SetActive: "Set Active",
        DocumentSetActive: "Document has been set as active"
    },
    stock: {
        Stock: "Stock",
        Articles: "Articles",
        Article: "Article",
        ArticleName: "Article Name",
        ArticleCode: "Article Code",
        ArticleType: "Article Type",
        EditArticle: "Edit Article",
        Manufacturer: "Manufacturer",
        Unit: "Unit amount",
        PackageType: "Package Type",
        ActiveIngredient: "Active Ingredient",
        Strength: "Strength",
        Description: "Description",
        StandardCost: "Standard Cost",
        RequiresPrescription: "Requires Prescription",
        IsControlledSubstance: "Is Controlled Substance",
        StorageConditions: "Storage Conditions",
        BasicInformation: "Basic Information",
        Inventory: "Inventory",
        StockLevels: "Stock Levels",
        StockLevel: "Stock Level",
        CreateLevel: "Create Level",
        EditLevel: "Edit Level", 
        AddLevel: "Add Level",
        LevelDetail: "Level Detail",
        CreateStockLevel: "Create Stock Level",
        EditStockLevel: "Edit Stock Level",
        NewStockLevel: "New Stock Level",
        EnterLevelName: "Enter level name",
        EnterLevelCode: "Enter level code", 
        EnterLevelDescription: "Enter level description",
        Level: "Level",
        Assignments: "Assignments", 
        AllResidents: "All Residents",
        Resident: "Resident",
        Items: "Items",
        StockItems: "Stock Items",
        AddItem: "Add Item",
        AddStockItem: "Add Stock Item",
        EditStockItem: "Edit Stock Item",
        NoItemsInLevel: "No items in this stock level",
        SearchByStockLevel: "Search by stock level",
        StockLevelFilter: "Stock Level Filter",
        NoStockLevelsFound: "No stock levels found",
        AddFirstItem: "Click 'Add Item' to add the first stock item",
        ViewStockLevel: "View Stock Level",
        Movements: "Movements",
        StockMovements: "Stock Movements",
        AddMovement: "Add Movement",
        MovementType: "Movement Type",
        StockItem: "Stock Item",
        Units: "Units",
        Pieces: "Pieces",
        Date: "Date",
        Reports: "Reports",
        Location: "Location",
        Quantity: "Quantity",
        CurrentQuantity: "Current Quantity",
        PieceQuantity: "Piece Quantity",
        OpenedQuantity: "Opened Unit Quantity",
        MinimumLevel: "Minimum Level",
        MaximumLevel: "Maximum Level",
        ReorderPoint: "Reorder Point",
        ReorderQuantity: "Reorder Quantity",
        BatchNumber: "Batch Number",
        ExpiryDate: "Expiry Date",
        PackageOpenDate: "Unit Open Date",
        LastMovement: "Last Movement",
        BatchLabel: "Batch",
        ExpiryLabel: "Exp",
        NotAvailable: "N/A",
        Min: "Min",
        Max: "Max",
        Batch: "Batch",
        Expires: "Expires",
        MinMaxLevels: "Min/Max Levels",
        BatchExpiry: "Batch/Expiry",
        StockArticle: "Stock Article",
        SelectArticle: "Select Article",
        SelectResidents: "Select Resident",
        SelectStockLevels: "Select Stock Level",
        SelectStockLevel: "Select Stock Level",
        FromStockLevel: "From Stock Level",
        ToStockLevel: "To Stock Level",
        FromLevel: "From Level",
        ToLevel: "To Level",
        Note: "Note",
        SelectDestinationLevel: "Select destination level",
        SelectLevelWithStock: "Select a stock level with available items (quantity > 0)",
        AvailableArticles: "Available Articles",
        SelectedArticle: "Selected Article",
        StockItemDetails: "Stock Item Details",
        StockItemDetail: "Stock Item Detail",
        PleaseSelectArticle: "Please select an article to continue",
        NoArticlesFound: "No articles found",
        TryDifferentSearch: "Try adjusting your search terms or filters",
        Cost: "Cost",
        Dashboard: "Dashboard",
        Code: "Code",
        EnterLocation: "Enter Location",
        EnterQuantity: "Enter Quantity",
    EnterPackageQuantity: "Enter Unit Quantity",
    UnitsSuffix: "units",
    PiecesSuffix: "pieces",
    PackagesSuffix: "units",
        EnterMinLevel: "Enter Minimum Level",
        FullPackagesCount: "Full, unopened units (containers)",
        LoosePiecesFromOpenedUnits: "Loose pieces from opened units",
        PiecesPerUnit: "Pieces per unit",
        TotalPieces: "Total pieces",
    TotalUnits: "Total Units",
        TotalPurchaseValue: "Total Purchase Value",
        CostPerPiece: "Cost per piece",
    CostPerUnit: "Cost per Unit",
    StockValue: "Stock Value",
        WillBeNormalizedTo: "Will be normalized to",
        EnterMaxLevel: "Enter Maximum Level",
        EnterReorderPoint: "Enter Reorder Point",
        EnterReorderQuantity: "Enter Reorder Quantity",
        EnterBatchNumber: "Enter Batch Number",
        SelectExpiryDate: "Select Expiry Date",
        ReorderPointHelp: "Quantity level that triggers reorder alert",
        ReorderQuantityHelp: "Recommended quantity to order",
        SearchByArticleOrLocation: "Search by article name, code, or location",
        FilterByArticle: "Filter by Article",
        FilterByStockStatus: "Filter by Stock Status",
        FilterByMainLevel: "Filter by Main Level",
        AllStock: "All Stock",
        InStock: "In Stock",
        LowStock: "Low Stock",
        OutOfStock: "Out of Stock",
        ShowAllStock: "Show All Stock",
        ShowLowStockOnly: "Show Low Stock Only",
        ShowAllLevels: "Show All Levels",
        ShowLowStockLevels: "Show Low Stock",
        LevelType: "Level Type",
        IsMainLevel: "Is main level?",
        MainLevel: "Main Level",
        SubLevel: "Sub Level",
        MainLevels: "Main Levels",
        SubLevels: "Sub Levels",
        TotalItems: "Total Items",
        StockDashboard: "Stock Dashboard",
        TotalStockValue: "Total Stock Value",
        InventoryValue: "Inventory Value",
        LowStockItems: "Low Stock Items",
        ItemsBelowMinimum: "Items below minimum",
        ExpiredItems: "Expired Items",
        RequireAttention: "Require attention",
        ActiveItems: "Active Items",
        StockValueTrend: "Stock Value Trend",
        StockValueByLocation: "Stock Value by Location",
        InvoicedVsNonInvoiced: "Invoiced vs Non-Invoiced Items",
        Invoiced: "Invoiced",
        NotInvoiced: "Not Invoiced",
        TopArticlesByValue: "Top Articles by Value",
        Value: "Value",
        LowStockArticles: "Low Stock Articles",
        ExpiringItems: "Expiring Items",
        AllLevels: "All Levels",
        WithLowStock: "With Low Stock",
        NoLowStock: "No Low Stock",
        WithExpiringItems: "With Expiring Items",
        Expiring: "Expiring",
        StockLevelCreated: "Stock level created successfully",
        StockLevelUpdated: "Stock level updated successfully",
        AssignmentDeletedSuccess: "Assignment deleted successfully",
        ErrorLoadingArticles: "Error loading stock articles",
        ErrorLoadingStockLevel: "Error loading stock level",
        AddStockArticle: "Add Article",
        StockArticleCreated: "Stock article created successfully"
        ,
        // Stock movement translations
        RecordMovement: "Record Movement",
        QuickRecordDescription: "Quickly record stock movements, adjustments, and transfers",
        RefReason: "Reference / Reason",
        LoadMovementsError: "Failed to load movements",
        MovementRecorded: "Movement recorded successfully",
        RecordMovementError: "Failed to record movement",
        Reason: "Reason",
        Available: "Available",
        AvailableUnits: "Available Units",
        UnitsAvailable: "{count} units available",
        ExceedsAvailable: "Exceeds available units ({available})",
        PurchaseCostPerUnit: "Purchase Cost Per Unit",
        EnterPurchaseCost: "Enter purchase cost per unit",
        PurchaseCostDescription: "Actual cost paid for this specific batch/lot. Used for accurate invoice calculations.",
        BulkAddItems: "Bulk Add Items",
        BulkItemsAdded: "Stock items added successfully",
        BulkItemsAddError: "Failed to add stock items",
        SelectResidentStockLevel: "Select the resident's stock level to add items",
        PackageQuantity: "Package Quantity"
    },
    stockLevel: {
        AssignmentDetailHeader: "Stock Level Assignment"
    },
    dashboard: {
        BookService: "Book a Service",
        Welcome: "Welcome to Akersoni teenused",
        BookingManagementSystem: "Therapy Booking Management System",
        TodayBookings: "Today's Bookings",
        ConfirmedBookings: "Confirmed",
        TotalClients: "Total Clients",
        ActiveServices: "Active Services",
        QuickActions: "Quick Actions",
        MyBookings: "My Bookings",
        ViewAndManageYourBookings: "View and manage your therapy bookings",
        UpcomingBookings: "Upcoming Bookings",
        YourNext10Bookings: "Your next 10 bookings",
        NoUpcomingBookings: "No upcoming bookings"
    },
    booking: {
        CreateBooking: "Create Booking",
        ViewBookings: "View Bookings",
        ManageBookings: "Manage Bookings",
        Bookings: "Bookings",
        CalendarTitle: "Booking Calendar",
        Calendar: "Calendar",
        EditBooking: "Edit Booking",
        BookingSaved: "Booking saved successfully",
        SaveFailed: "Failed to save booking",
        Client: "Client",
        Service: "Service",
        Employee: "Employee",
        Room: "Room",
        Status: "Status",
        StartDate: "Start Date",
        EndDate: "End Date",
        StartDateTime: "Start Date/Time",
        EndDateTime: "End Date/Time",
        BookingTime: "Booking Time",
        Participants: "Participants",
        Notes: "Notes",
        InternalComment: "Internal comment",
        CancellationReason: "Cancellation Reason",
        ConflictDetected: "Conflict Detected",
        ConflictEmployeeBooked: "Employee is already booked at this time",
        ConflictRoomOccupied: "Room is already occupied at this time",
        ConflictTimeUnavailable: "Selected time slot is not available",
        ConflictCapacityExceeded: "Maximum capacity exceeded for this service",
        PublicHolidayDayOff: "The selected time falls on a public holiday marked as a day off",
        ConflictGeneric: "Booking conflict detected",
        ClearConflict: "Dismiss",
        Templates: "Templates",
        SlotsRemaining: "slots remaining",
        ParticipantsFilled: "participants filled",
        Full: "Full",
        MaxCapacityReached: "Maximum capacity reached",
        Selected: "selected",
        PreHoldExpiring: "Pre-hold expiring soon",
        Expired: "Expired",
        Remaining: "remaining",
        SelectClient: "Select client",
        SelectService: "Select service",
        SelectEmployee: "Select employee",
        SelectRoom: "Select room",
        SelectStatus: "Select status",
        BookingStatus: "Booking Status",
        SelectParticipants: "Select participants",
        SelectCancellationReason: "Select cancellation reason",
        EnterNotes: "Enter notes",
        EnterInternalComment: "Enter internal comment",
        DropBookingsHere: "Drop bookings here",
        NoService: "No service",
        NoEmployee: "No employee",
        NoStatus: "No status",
        SpecialClient: "Special client",
        FilterByEmployee: "Filter by employee",
        AllEmployees: "All employees",
        AllStatuses: "All statuses",
        WeekView: "Week View",
        DayView: "Day View",
        Today: "Today",
        Week: "Week",
        Day: "Day",
        ShowTemplates: "Show Templates",
        HideTemplates: "Hide Templates",
        StatusPreHold: "Pre-hold",
        StatusConfirmed: "Confirmed",
        StatusCompleted: "Completed",
        StatusCancelled: "Cancelled",
        StatusWaitlisted: "Waitlisted",
        BookingDetails: "Booking Details",
        CreateNewBooking: "Create New Booking",
        SelectedTime: "Selected time",
        FormComingSoon: "Booking form coming soon",
        Updated: "Booking updated successfully",
        UpdateFailed: "Failed to update booking",
        ExpiresIn: "Expires in",
        ServiceInformation: "Service Information",
        DateTime: "Date & Time",
        LeadClient: "Lead Client",
        NotFound: "Booking not found",
        CancelBooking: "Cancel Booking",
        CancelConfirmation: "Are you sure you want to cancel this booking?",
        SelectReason: "Select a reason",
        CancellationNotesPlaceholder: "Optional notes about the cancellation...",
        Confirmed: "Booking confirmed successfully",
        ConfirmFailed: "Failed to confirm booking",
        Approve: "Approve",
        ApproveFallback: "Approve",
        Reject: "Reject",
        RejectFallback: "Reject",
        BookingApproved: "Booking approved successfully",
        ApproveFailed: "Failed to approve booking",
        BookingRejected: "Booking rejected successfully",
        RejectFailed: "Failed to reject booking",
        Cancelled: "Booking cancelled successfully",
        CancelFailed: "Failed to cancel booking",
        LoadFailed: "Failed to load booking",
        LoadBookingsFailed: "Failed to load bookings",
        CreatedSuccessfully: "Booking created successfully",
        CreateFailed: "Failed to create booking",
        SendNotificationPrompt: "Would you like to send an email notification to the lead client?",
        SendNotification: "Send Notification",
        ConfirmSendNotification: "Send booking notification to this client?",
        NotificationSent: "Booking notification sent successfully",
        FailedToSendNotification: "Failed to send booking notification",
        DontSendNotification: "Don't Send",
        LeadClientNoUser: "Warning: The lead client does not have a user account and cannot receive email notifications.",
        EmployeeConflict: "Employee is already booked at this time. Please select a different time or employee.",
        RoomConflict: "Room is already occupied at this time. Please select a different time or room.",
        ClientConflict: "One or more clients already have conflicting bookings at this time. Please select a different time.",
        MissingSkills: "Missing required skills",
        StartTime: "Start Time",
        EndTime: "End Time",
        EndsAt: "Ends at",
        AdditionalParticipants: "Additional Participants",
        SelectAdditionalClients: "Select additional clients",
        ParticipantsSingular: "participant",
        ParticipantsPlural: "participants",
        NoClientRequired: "No client required",
        NoClientRequiredTooltip: "Check this for consultations or reviews with prospective clients not yet in the system",
        CapacityAvailable: "{count} spots available",
        IndividualServiceOneParticipant: "Individual service - only 1 participant allowed",
        CapacityExceeded: "Capacity exceeded - maximum {max} participants allowed",
        "Conflict.EMPLOYEE_BOOKED": "Employee is already booked at this time",
        "Conflict.ROOM_OCCUPIED": "Room is already occupied at this time",
        "Conflict.TIME_UNAVAILABLE": "Selected time slot is not available",
        "Conflict.CAPACITY_EXCEEDED": "Maximum capacity exceeded",
        NoTemplatesAvailable: "No service templates available",
        NoBookingsFound: "No bookings found",
        BookingDetail: "Booking Detail",
        ClientCancelled: "Client Cancelled",
        StaffCancelled: "Staff Cancelled",
        NoShow: "No Show",
        Rescheduled: "Rescheduled",
        Confirm: "Confirm",
        // Bulk Available Slots
        CreateBulkAvailableSlots: "Create Bulk Available Slots",
        CreateMultipleBookings: "Create Multiple Bookings",
        AddMultipleDates: "Add Multiple Dates",
        DuplicateToMultipleDates: "Duplicate To Multiple Dates",
        BulkSlotsCreatedSuccess: "{count} available slot(s) created successfully",
        BulkSlotsCreationFailed: "Failed to create available slots",
        MultipleBookingsCreatedSuccess: "{count} booking(s) created successfully",
        MultipleBookingsCreatedPartial: "Created {created} booking(s), skipped {skipped}",
        SelectStartDate: "Select start date",
        SelectEndDate: "Select end date",
        SelectStartTime: "Select start time",
        SelectEndTime: "Select end time",
        PreferredTime: "Preferred time",
        PreferredStartTime: "Preferred start time",
        PreferredTimeHelp: "When you select a date, the system first tries this time. If it is not free, choose one of the suggested times for that day.",
        QuickTimes: "Quick times",
        NoQuickTimesYet: "No recent times yet",
        CustomPreferredTime: "Custom preferred time",
        TemplateParticipants: "Participants",
        SelectAdditionalDates: "Select additional dates",
        SelectAdditionalDatesHelp: "Green days support your preferred time. Amber days have other free times. Gray days are unavailable.",
        DayHasPreferredTime: "Preferred time available",
        DayHasAlternativeTimes: "Alternative times available",
        DayUnavailable: "No times available",
        SelectedDates: "Selected dates",
        SelectedDatesCount: "{count} selected",
        NoDatesSelected: "No dates selected yet",
        Ready: "Ready",
        NeedsTimeSelection: "Needs time",
        ChooseTimeForDate: "Choose a time for this date",
        AvailableTimesForDay: "Available times for selected date",
        SelectDateToSeeTimes: "Select a date to see available times",
        NoTimeSlotsAvailableForDate: "No available times for this date",
        LoadAvailabilityFailed: "Failed to load availability",
        SelectedSlotNoLongerAvailable: "Selected slot is no longer available. Please choose again.",
        BookingsCreatedCount: "Created: {count}",
        BookingsSkippedCount: "Skipped: {count}",
        BulkBookingFooterHelp: "Each selected date must have an assigned time before saving.",
        TemplateBuildFailed: "Failed to prepare booking template",
        DaysOfWeek: "Days of Week",
        DaysOfWeekHelp: "Select which days of the week to create slots",
        SlotDuration: "Slot Duration",
        UseDefaultRoom: "Use default room (leave empty)",
        RoomOptionalHelp: "If no room is selected, the employee's default room will be used",
        CreationSummary: "Creation Summary",
        SlotsCreated: "Slots Created",
        SlotsSkipped: "Slots Skipped",
        SkippedDetails: "Skipped Slots Details",
        SlotsSkippedMessage: "{count} slot(s) were skipped due to conflicts",
        FixedSlotTemplate: "Fixed service slot",
        FixedSlotMissingEmployee: "Employee not assigned yet"
    },
    service: {
        ManageServices: "Manage Services",
        Services: "Services",
        Service: "Service",
        Name: "Service Name",
        ServiceName: "Service Name",
        Category: "Category",
        ServiceType: "Service Type",
        SelectServiceType: "Select service type",
        ServiceTypeHelp: "Optional classification for organizing your services",
        ClientType: "Client Type",
        SelectClientType: "Select client type",
        ClientTypeHelp: "Optional - specify which client type this service is for (Adult, Child, etc.)",
        Duration: "Duration",
        Minutes: "minutes",
        Price: "Price",
        MaxCapacity: "Max Capacity",
        Description: "Description",
        IsActive: "Active",
        IsPublic: "For Public",
        IsPassEligible: "Pass Eligible",
        PassEligible: "Pass Eligible",
        IsPayable: "Requires payment",
        ServiceMarkedPublic: "Service marked as available for public booking",
        ServiceMarkedPrivate: "Service marked as private (not available for public booking)",
        ErrorUpdatingService: "Error updating service",
        CreateService: "Create Service",
        EditService: "Edit Service",
        EnterName: "Enter service name",
        SelectCategory: "Select category",
        EnterDuration: "Enter duration in minutes",
        EnterPrice: "Enter price",
        EnterMaxCapacity: "Enter maximum capacity",
        EnterDescription: "Enter service description",
        FilterByCategory: "Filter by category",
        FilterByStatus: "Filter by status",
        ServiceSaved: "Service saved successfully",
        ServiceDeleted: "Service deleted successfully",
        ErrorLoadingService: "Error loading service",
        ErrorSavingService: "Error saving service",
        ErrorDeletingService: "Error deleting service",
        ConfirmDelete: "Are you sure you want to delete this service?",
        IndividualHelpText: "One-on-one therapy sessions",
        GroupHelpText: "Group therapy - multiple participants",
        IndividualCapacityFixed: "Individual service capacity is always 1",
        DisplayedAs: "Displayed as",
        QuickDuration: "Quick duration selection",
        Code: "Service Code",
        CodePlaceholder: "e.g., PT-60, MT-45, GRP-T",
        CodeHelp: "Recommended format: [Category]-[Duration]",
        AccountingCode: "Accounting Code",
        AccountingCodePlaceholder: "e.g., ACCT-001",
        Color: "Service Color",
        SelectColor: "Select Color",
        IndividualServices: "Individual Services",
        GroupServices: "Group Services",
        RequiredSkills: "Required Skills",
        SelectRequiredSkills: "Select required skills",
        RequiredSkillsHelp: "Employees must have these skills to provide this service",
        AssignedEmployee: "Assigned Employee",
        SelectService: "Select service",
        SelectEmployee: "Select employee",
        SelectSkillsFirst: "Select required skills first",
        AssignedEmployeeHelp: "Default employee for this service",
        AssignedRoom: "Assigned Room",
        SelectRoom: "Select room",
        AssignedRoomHelp: "Default room for this service",
        AddNewService: "Add New Service",
        IsSpecial: "Special Service (VIP/Priority)",
        UseFixedSlots: "Use fixed weekly slots",
        FixedSlotsHelp: "When enabled, public booking slots are generated only from these day/time rules.",
        FixedSlotTimeInvalid: "Enter start time in HH:mm format",
        StartTime: "Start Time",
        PassEligibilityEnabled: "Pass eligibility enabled for {serviceName}",
        PassEligibilityDisabled: "Pass eligibility disabled for {serviceName}"
    },
    servicePass: {
        ServicePasses: "Service Passes",
        ServicePass: "Service Pass",
        Passes: "Passes",
        ManageServicePasses: "Manage Service Passes",
        CreateServicePass: "Create Service Pass",
        EditServicePass: "Edit Service Pass",
        PassDefinitions: "Pass Definitions",
        ClientPasses: "Client Passes",
        SelectClientToViewPasses: "Select a client to view their passes",
        SelectClientFirst: "Please select a client first to view their passes",
        Owner: "Owner",
        Sessions: "Sessions",
        PassName: "Pass Name",
        PassNameHelp: "Name shown to clients when purchasing a pass",
        PassDescription: "Description",
        SessionCount: "Number of Sessions",
        Price: "Total Price",
        ValidityDays: "Validity Period (Days)",
        IsActive: "Active",
        PricePerSession: "Price per Session",
        HasExpiry: "Has Expiry Date",
        SetExpiryPeriod: "Set expiry period",
        NoExpiry: "No expiry",
        SelectService: "Select Service",
        SelectServiceFirst: "Please select a service first",
        EnterPassName: "Enter pass name",
        EnterDescription: "Enter description",
        EnterSessionCount: "Enter number of sessions",
        EnterPrice: "Enter total price",
        EnterValidityDays: "Enter validity period in days",
        SessionCountHelp: "Total number of sessions included in this pass",
        PriceHelp: "Total price for all sessions in the pass",
        ValidityDaysHelp: "Number of days from purchase date before the pass expires (leave empty for no expiry)",
        PassNameRequired: "Pass name is required",
        SessionCountRequired: "Number of sessions is required",
        SessionCountRange: "Session count must be between 1 and 100",
        PriceRequired: "Price is required",
        PricePositive: "Price must be positive",
        ValidityDaysRange: "Validity days must be between 1 and 365",
        ServicePassSaved: "Service pass saved successfully",
        ServicePassDeleted: "Service pass deleted successfully",
        ErrorLoadingPasses: "Error loading service passes",
        ErrorSavingPass: "Error saving service pass",
        ErrorDeletingPass: "Error deleting service pass",
        ConfirmDelete: "Are you sure you want to delete this service pass?",
        EmptyStateMessage: "No service passes found for this service. Create a pass to offer session packages to clients.",
        CreateFirstPass: "Create Your First Service Pass",
        MyPasses: "My Passes",
        PurchasePass: "Purchase Pass",
        PassDetails: "Pass Details",
        RemainingSessionsLabel: "Remaining",
        SessionsUsed: "Sessions Used",
        PurchaseDate: "Purchase Date",
        ExpiryDate: "Expiry Date",
        ExpiryDateOptional: "Expiry date is optional. Leave empty for no expiry.",
        ExpiryDateMustBeAfterPurchaseDate: "Expiry date must be after purchase date",
        Status: "Status",
        UsageHistory: "Usage History",
        ViewUsageHistory: "View Usage History",
        ViewUsage: "View Usage",
        NoUsageHistory: "No usage history found",
        UsedOn: "Used On",
        BookingReference: "Booking Reference",
        Active: "Active",
        Depleted: "Depleted",
        Expired: "Expired",
        Cancelled: "Cancelled",
        PassPurchased: "Pass purchased successfully",
        ErrorPurchasingPass: "Error purchasing pass",
        ErrorUpdatingPass: "Error updating pass",
        ErrorLoadingPassDetails: "Error loading pass details",
        ErrorLoadingUsageHistory: "Error loading usage history",
        SelectPass: "Select a pass",
        AvailablePasses: "Available Passes",
        NoPasses: "No passes available",
        NoClientProfile: "No client profile found. Please contact support.",
        PassProgress: "Pass Progress",
        SessionsRemaining: "{count} session(s) remaining",
        PassExpiring: "Expires in {days} day(s)",
        PassExpired: "This pass has expired",
        PurchaseForChild: "Optional - purchase this pass for a specific child, or leave empty to purchase for yourself",
        ErrorLoadingServices: "Error loading services",
        SearchClientOrChild: "Search for a client or child",
        OwnerHelp: "Search and select the client or their child who will own this pass",
        EditClientPass: "Edit Client Pass",
        EditNotSupported: "Editing purchased passes is not currently supported",
        HasActivePass: "Has active pass for this service",
        PassSessionsRemaining: "{remaining} of {total} sessions remaining",
        RemainingSessions: "Remaining sessions",
        RemainingSessionsHelp: "Optional: set the starting remaining sessions for this pass.",
        RemainingSessionsPlaceholder: "Default: {total}",
        SessionsUsedHelp: "Enter how many times this pass has already been used. This updates the remaining sessions but does not backfill usage history entries.",
        AddBookingUsage: "Add used booking",
        AddBookingUsageHelp: "Open the picker and choose an existing past booking for the same owner and same service.",
        SelectBookingUsage: "Select used booking",
        SelectBookingUsageHelp: "Only past bookings for the same owner and same service that are not already linked to this pass are shown.",
        EligibleBookings: "Eligible bookings: {count}",
        NoEligibleBookingsForPass: "No eligible bookings found for this pass.",
        ErrorLoadingEligibleBookings: "Failed to load eligible bookings",
        BookingUsageAdded: "Booking added to pass usage history",
        ErrorAddingBookingUsage: "Failed to add booking to pass usage history",
        ActiveServicePasses: "Active Service Passes",
        NoPassEligibleServices: "No pass-eligible services found. Enable pass eligibility in service settings first.",
        OnlyPassEligibleServicesShown: "Only pass-eligible services are shown.",
        ManageServices: "Manage Services",
        ManagePassEligibility: "Manage Service Pass Eligibility",
        BeforeBooking: "before booking"
    },
    room: {
        Room: "Room",
        Rooms: "Rooms",
        RoomList: "Room List",
        RoomDetails: "Room Details",
        CreateRoom: "Create Room",
        EditRoom: "Edit Room",
        DeleteRoom: "Delete Room",
        Name: "Room Name",
        Description: "Description",
        Location: "Location",
        Capacity: "Capacity",
        IsActive: "Active",
        SelectRoom: "Select Room",
        NameRequired: "Room name is required",
        CapacityRequired: "Capacity is required",
        CapacityRange: "Capacity must be between 1 and 100",
        InsufficientCapacity: "Room capacity ({roomCapacity}) is insufficient for service max capacity ({serviceCapacity})",
        RoomCreated: "Room created successfully",
        RoomUpdated: "Room updated successfully",
        RoomDeleted: "Room deleted successfully",
        CannotDeleteWithBookings: "Cannot delete room with future bookings",
        ErrorLoadingRooms: "Error loading rooms",
        ErrorSavingRoom: "Error saving room",
        ErrorDeletingRoom: "Error deleting room",
        EmptyStateMessage: "No rooms found. Create your first therapy room to start booking sessions.",
        CreateFirstRoom: "Create Your First Room",
        EnterName: "Enter room name",
        EnterDescription: "Enter description",
        EnterLocation: "Enter location",
        EnterCapacity: "Enter capacity",
        HasFutureBookings: "This room has {count} future booking(s) and cannot be deleted"
    },
    qualification: {
        Qualifications: "Qualifications",
        Qualification: "Qualification",
        ManageQualifications: "Manage Qualifications",
        Name: "Qualification Name",
        Code: "Qualification Code",
        Description: "Description",
        Category: "Category",
        IsActive: "Active",
        RequiresExpiry: "Requires Expiry",
        ValidityPeriodMonths: "Validity Period (Months)",
        CreateQualification: "Create Qualification",
        EditQualification: "Edit Qualification",
        EnterName: "Enter qualification name",
        EnterCode: "Enter qualification code",
        EnterDescription: "Enter description",
        SelectCategory: "Select category",
        EnterValidityPeriod: "Enter validity period in months",
        QualificationSaved: "Qualification saved successfully",
        QualificationDeleted: "Qualification deleted successfully",
        ErrorLoadingQualifications: "Error loading qualifications",
        ErrorLoadingQualification: "Error loading qualification",
        ErrorSavingQualification: "Error saving qualification",
        ErrorDeletingQualification: "Error deleting qualification",
        NoQualificationsFound: "No qualifications found",
        ValidityPeriodHelp: "Number of months the qualification remains valid (e.g., 12 for annual renewal)",
        RequiresExpiryHelp: "Enable if this qualification requires periodic renewal"
    },
    employee: {
        Employees: "Employees",
        Employee: "Employee",
        Therapist: "Therapist",
        ManageEmployees: "Manage Employees",
        CreateEmployee: "Create Employee",
        EditEmployee: "Edit Employee",
        EmployeeDetail: "Employee Detail",
        Name: "Name",
        FirstName: "First Name",
        LastName: "Last Name",
        Email: "Email",
        Phone: "Phone",
        User: "User",
        Status: "Status",
        Skills: "Skills",
        IsActive: "Is Active",
        BasicInfo: "Basic Information",
        Qualifications: "Qualifications",
        WorkSchedules: "Work Schedules",
        Unavailability: "Unavailability",
        Bookings: "Bookings",
        SelectEmployee: "Select employee",
        SelectStatus: "Select Status",
        SelectSkills: "Select Skills",
        EnterFirstName: "Enter first name",
        EnterLastName: "Enter last name",
        EnterEmail: "Enter email address",
        EnterPhone: "Enter phone number",
        FirstNameRequired: "First name is required",
        LastNameRequired: "Last name is required",
        StatusRequired: "Status is required",
        EmployeeRequired: "Employee is required",
        LoadError: "Failed to load employees",
        LinkedUser: "Linked User Account",
        SelectUser: "Select user account (optional)",
        NoUsersAvailable: "No users available",
        UserMappingHint: "Link this employee to a user account for system access. This is optional and can be done later.",
        FailedToLoadUsers: "Failed to load available users",
        EmployeeCreated: "Employee created successfully",
        EmployeeUpdated: "Employee updated successfully",
        EmployeeDeleted: "Employee deleted successfully",
        SaveFailed: "Failed to save employee",
        LoadFailed: "Failed to load employee data",
        SkillsDescription: "Manage employee skills and competencies",
        QualificationsDescription: "Track employee qualifications, certifications, and expiry dates",
        WorkSchedulesDescription: "Define recurring work schedules and availability patterns",
        UnavailabilityDescription: "Record sick leave, vacation, and other unavailability periods",
        QualificationsComingSoon: "Qualifications management coming soon",
        WorkSchedulesComingSoon: "Work schedules management coming soon",
        UnavailabilityComingSoon: "Unavailability management coming soon",
        FilterByActive: "Filter by active status",
        AcquiredDate: "Acquired Date",
        ExpiresOn: "Expires On",
        CertificationNumber: "Certification Number",
        NoExpiry: "No Expiry",
        Expired: "Expired",
        ExpiringSoon: "Expiring in {days} days",
        Valid: "Valid",
        NoQualifications: "No qualifications assigned",
        AddQualification: "Add Qualification",
        EditQualification: "Edit Qualification",
        QualificationRequired: "Qualification is required",
        QualificationSaved: "Qualification saved successfully",
        SaveQualificationFailed: "Failed to save qualification",
        LoadQualificationsFailed: "Failed to load qualifications",
        SelectAcquiredDate: "Select acquired date",
        SelectExpiryDate: "Select expiry date (optional)",
        ExpiryDateOptional: "Leave empty if qualification does not expire",
        EnterCertificationNumber: "Enter certification/license number",
        EnterNotes: "Enter additional notes",
        // Absence Management
        Absences: "Absences",
        CreateAbsence: "Create Absence",
        EditAbsence: "Edit Absence",
        AbsenceCreated: "Absence created successfully",
        AbsenceDeleted: "Absence deleted successfully",
        AbsenceFailed: "Failed to manage absence",
        LoadAbsencesFailed: "Failed to load absences",
        NoAbsences: "No absences recorded",
        AbsenceStartTime: "Absence Start",
        AbsenceEndTime: "Absence End",
        AbsenceReason: "Absence Reason",
        AbsenceReasonOptional: "Reason is optional",
        SelectAbsenceReason: "Select reason (optional)",
        AbsenceStartRequired: "Start time is required",
        AbsenceEndRequired: "End time is required",
        AbsenceCannotBePast: "Absence cannot be in the past",
        AbsenceOverlapError: "This absence overlaps with an existing absence",
        AbsenceAffectedBookings: "Affected Bookings",
        AbsenceSubstituteMatch: "Substitute Match",
        AbsenceNoSubstitute: "No substitute available",
        AbsenceBookingsWillBeCancelled: "Affected bookings will be cancelled if no substitute is found",
        AbsenceBookingsReassigned: "Bookings reassigned to substitute",
        AbsenceBookingsCancelled: "Bookings cancelled",
        AbsenceDeleteWarning: "Deleting this absence will NOT restore cancelled bookings",
        AbsenceAllDay: "All day",
        AllDayAbsenceInfo: "The absence applies for the entire day (00:00 – 24:00). The end time is automatically set to the beginning of the next day.",
        NoReasonProvided: "No reason provided",
        DefaultRoom: "Default Room",
        SelectDefaultRoom: "Select default room (optional)",
        DefaultRoomHelp: "This room will be used by default when creating available slots",
        NoEmployeeRecordFound: "No employee record found for your account",
        ContactAdministrator: "Please contact your administrator to link your account to an employee record",
        // Work Schedule Management
        NoSchedules: "No work schedules defined",
        AddFirstSchedule: "Add your first work schedule",
        AddSchedule: "Add Schedule",
        EditSchedule: "Edit Schedule",
        DayOfWeek: "Day of Week",
        StartTime: "Start Time",
        EndTime: "End Time",
        RecurringPattern: "Recurring Pattern",
        SelectRecurringPattern: "Select recurring pattern",
        EffectiveFrom: "Effective From",
        EffectiveTo: "Effective To",
        SelectDate: "Select date",
        SelectDay: "Select day",
        SelectDays: "Select days",
        TimeFormat: "HH:MM",
        ScheduleCreated: "Schedule created successfully",
        ScheduleUpdated: "Schedule updated successfully",
        FailedToLoadSchedules: "Failed to load schedules",
        FailedToSaveSchedule: "Failed to save schedule"
    },
    client: {
        Clients: "Clients",
        Client: "Client",
        ClientName: "Client Name",
        ManageClients: "Manage Clients",
        CreateClient: "Create Client",
        EditClient: "Edit Client",
        ClientDetail: "Client Detail",
        ClientList: "Client List",
        ClientBookings: "Client Bookings",
        BasicInfo: "Basic Information",
        ServiceInfo: "Service Information",
        FirstName: "First Name",
        LastName: "Last Name",
        Name: "Name",
        PersonalCode: "Personal Code",
        PhoneNumber: "Phone Number",
        Email: "Email",
        Phone: "Phone",
        Address: "Address",
        IdentityCode: "Identity Code",
        BirthDate: "Birth Date",
        Notes: "Notes",
        Category: "Category",
        ClientType: "Client Type",
        SelectClientType: "Select client type",
        DefaultLanguage: "Preferred Language",
        SelectDefaultLanguage: "Select preferred language",
        DefaultLanguageHelp: "Language to use for notifications and communications",
        PreferredServices: "Preferred Service Types",
        SelectPreferredServices: "Select preferred service types",
        PreferredServicesHelp: "Service types commonly used by this client/child for faster booking",
        Preferences: "Preferences",
        IsActive: "Is Active",
        InactiveReason: "Inactive reason",
        EnterInactiveReason: "Enter inactive reason",
        InactiveReasonHelp: "Briefly describe why the client was marked inactive. Example: service completed, recovered, and no longer needs the service.",
        InactiveReasonRequired: "Inactive clients must have a reason",
        NoInactiveReasonProvided: "No inactive reason provided",
        InactiveStatusSummary: "Client is marked as inactive",
        HasUser: "User",
        HasUserAccount: "Has User",
        NoUserAccount: "No User",
        UserAccount: "User Account",
        SelectUserAccount: "Select user account (optional)",
        UserAccountOptional: "User account is optional - only needed if client will log in",
        SelectCategory: "Select category",
        SelectPreferences: "Select preferences",
        EnterFirstName: "Enter first name",
        EnterLastName: "Enter last name",
        EnterPersonalCode: "Enter Estonian personal code",
        EnterPhoneNumber: "Enter phone number",
        EnterEmail: "Enter email address",
        EnterAddress: "Enter address",
        PersonalCodeHint: "11-digit Estonian personal identification code (Isikukood)",
        InvalidPersonalCode: "Invalid personal code. Please check the format and checksum.",
        FilterByCategory: "Filter by category",
        FilterByClientType: "Filter by client type",
        FirstNameRequired: "First name is required",
        LastNameRequired: "Last name is required",
        PersonalCodeRequired: "Personal code is required",
        CategoryRequired: "Category is required",
        EmailRequired: "Email is required",
        EmailInvalid: "Email is invalid",
        ClientCreatedSuccessfully: "Client created successfully",
        ClientUpdatedSuccessfully: "Client updated successfully",
        ClientDeletedSuccessfully: "Client deleted successfully",
        ProfileUpdatedSuccessfully: "Profile updated successfully",
        ProfileUpdateFailed: "Failed to update profile",
        FailedToCreateClient: "Failed to create client",
        FailedToUpdateClient: "Failed to update client",
        FailedToDeleteClient: "Failed to delete client",
        FailedToLoadClient: "Failed to load client",
        FailedToLoadClients: "Failed to load clients",
        ServiceInfoDescription: "View client service history and upcoming appointments",
        LeadClient: "Lead Client",
        SelectClient: "Select client",
        ServiceInfoComingSoon: "Service information and booking history coming soon",
        ClientChildren: "Client's Children",
        NoClientRecordFound: "No client record found for your account",
        ContactAdministrator: "Please contact the administrator for assistance",
        Myself: "For Myself",
        SelectChild: "Select Child",
        SearchClient: "Search for a client",
        ChildOf: "child of"
    },
    clientChild: {
        Name: "Name",
        BasicInfo: "Basic Information",
        FirstName: "First Name",
        LastName: "Last Name",
        IdentityCode: "Identity Code",
        BirthDate: "Birth Date",
        AddChild: "Add Child",
        EditChild: "Edit Child",
        DeleteChild: "Delete Child",
        ChildDetails: "Child Details",
        ParentClient: "Parent Client",
        NoChildren: "No children registered",
        ChildrenList: "Children List",
        FirstNameRequired: "First name is required",
        LastNameRequired: "Last name is required",
        IdentityCodeRequired: "Identity code is required",
        IdentityCodeInvalid: "Invalid Estonian identity code",
        BirthDateRequired: "Birth date is required",
        ChildCreatedSuccessfully: "Child added successfully",
        ChildUpdatedSuccessfully: "Child updated successfully",
        ChildDeletedSuccessfully: "Child deleted successfully",
        FailedToCreateChild: "Failed to add child",
        FailedToUpdateChild: "Failed to update child",
        FailedToDeleteChild: "Failed to delete child",
        FailedToLoadChildren: "Failed to load children",
        ConfirmDeleteChild: "Are you sure you want to delete this child?",
        PromoteToAdult: "Promote to Adult Client",
        PromoteConfirmation: "Are you sure you want to promote this child to an adult client?",
        PromotedSuccessfully: "Child promoted to adult client successfully"
    },
    clientContract: {
        Title: "Contracts",
        ContractList: "Contracts",
        ResidueList: "Residues",
        Contract: "Contract",
        Contracts: "Contracts",
        StartDate: "Start Date",
        EndDate: "End Date",
        YearlyResidue: "Yearly Residue",
        ContractCode: "Contract Code",
        BookingNotes: "Service content",
        Year: "Year",
        TotalResidue: "Total Residue",
        UsedAmount: "Used Amount",
        UnusedAmount: "Unused Amount",
        CreateContract: "Create Contract",
        EditContract: "Edit Contract",
        DeleteContract: "Delete Contract",
        RecalculateResidues: "Recalculate Residues",
        StartDateRequired: "Start date is required",
        EndDateRequired: "End date is required",
        YearlyResidueRequired: "Yearly residue is required",
        ContractPeriod: "Contract Period",
        NoContracts: "No contracts found",
        SelectContractToViewResidues: "Select a contract to view residues",
        ContractCreatedSuccessfully: "Contract created successfully",
        ContractUpdatedSuccessfully: "Contract updated successfully",
        ContractDeletedSuccessfully: "Contract deleted successfully",
        FailedToCreateContract: "Failed to create contract",
        FailedToUpdateContract: "Failed to update contract",
        FailedToDeleteContract: "Failed to delete contract",
        FailedToLoadContracts: "Failed to load contracts",
        ConfirmDeleteContract: "Are you sure you want to delete this contract?"
    },
    suggestion: {
        Suggestions: "Suggestions",
        MySuggestions: "My Suggestions",
        ClientSuggestions: "Client Suggestions",
        AddSuggestion: "Add Suggestion",
        EditSuggestion: "Edit Suggestion",
        Suggestion: "Suggestion",
        Title: "Title",
        Description: "Description",
        Date: "Date",
        Client: "Client",
        Therapist: "Therapist",
        DueDate: "Due Date",
        Status: "Status",
        CompletedDate: "Completed Date",
        CreatedDate: "Created Date",
        MarkAsDone: "Mark as Done",
        MarkAsCompleted: "Mark as completed",
        Done: "Done",
        Completed: "Completed",
        Overdue: "Overdue",
        NoSuggestionsFound: "No suggestions found",
        ConfirmMarkAsCompleted: "Are you sure you want to mark this suggestion as completed?",
        ConfirmDelete: "Are you sure you want to delete the suggestion '{title}'?",
        MarkedAsCompletedSuccess: "Suggestion marked as completed successfully",
        MarkedAsCompletedError: "Failed to mark suggestion as completed",
        LoadError: "Failed to load suggestions",
        CreateSuccess: "Suggestion created successfully",
        UpdateSuccess: "Suggestion updated successfully",
        DeleteSuccess: "Suggestion deleted successfully",
        SaveError: "Failed to save suggestion",
        DeleteError: "Failed to delete suggestion",
        TitleRequired: "Title is required",
        EnterTitle: "Enter title",
        EnterDescription: "Enter description (optional)",
        SelectDueDate: "Select due date (optional)",
        DueDateHint: "Choose a target date for completion",
        SelectStatus: "Select status",
        CreateSuggestion: "Create Suggestion",
        AddFromBookingHint: "Create a suggestion for this client based on this booking session"
    },
    notification: {
        ManageNotifications: "Manage Notifications",
        ManageNotificationsDescription: "View and manage all system notifications, including delivery status and resend capabilities",
        NotificationManagement: "Notification Management",
        NotificationList: "Notification List",
        NotificationId: "ID",
        NotificationDetails: "Notification Details",
        User: "User",
        Title: "Title",
        Message: "Message",
        Type: "Type",
        Status: "Status",
        Sent: "Sent",
        NotSent: "Not Sent",
        Read: "Read",
        Abandoned: "Abandoned",
        RetryCount: "Retry Count",
        Booking: "Booking",
        RelatedBooking: "Related Booking",
        CreatedOn: "Created On",
        SentOn: "Sent On",
        IsSent: "Is Sent",
        IsRead: "Is Read",
        IsAbandoned: "Is Abandoned",
        IsEmailSent: "Is Email Sent",
        EmailSentOn: "Email Sent On",
        EmailRetryCount: "Email Retry Count",
        EmailSent: "Email Sent",
        EmailPending: "Email Pending",
        FilterByUser: "Filter by User ID",
        FilterBySent: "Filter by Sent",
        FilterByRead: "Filter by Read",
        FilterByAbandoned: "Filter by Abandoned",
        UserIdPlaceholder: "Enter user ID",
        ResendNotification: "Resend Notification",
        ConfirmResend: "Confirm Resend",
        ConfirmResendMessage: "Are you sure you want to resend this notification?",
        Resend: "Resend",
        ResendSuccess: "Notification resent successfully",
        ResendFailed: "Failed to resend notification",
        ResendError: "Error resending notification",
        LoadNotificationsError: "Failed to load notifications",
        NoNotificationsFound: "No notifications found",
        DeliveryStatus: "Delivery Status",
        SignalRSentOn: "SignalR Sent On",
        SignalRRetryCount: "SignalR Retry Count",
        ReadOn: "Read On",
        NotRead: "Not Read",
    },
    user: {
        UserManagement: "User Management",
        Users: "Users",
        User: "User",
        Username: "Username",
        Password: "Password",
        ChangePassword: "Change Password",
        ChangePasswordMsg: "Your password has been changed successfully.",
        ErrorAtLogging: "Error occurred while logging in.",
        SuccessfullyLogged: "Successfully logged in.",
        Role: "Role",
        CreateUser: "Create User",
        EditUser: "Edit User",
        DeleteUser: "Delete User",
        SearchByUsernameOrEmail: "Search by username or email",
        FilterByRole: "Filter by role",
        SelectRole: "Select role",
        RoleHelperText: "Select a role for this user",
        UsernameRequired: "Username is required",
        PasswordRequired: "Password is required",
        RoleRequired: "Role is required",
        UserSavedSuccessfully: "User saved successfully",
        UserDeletedSuccessfully: "User deleted successfully",
        ErrorLoadingUsers: "Error loading users",
        ErrorSavingUser: "Error saving user",
        ErrorDeletingUser: "Error deleting user",
        CannotDeleteYourself: "You cannot delete your own account",
        CannotDeleteSystemAdmin: "Cannot delete system administrator",
        ComingSoon: "User management coming soon - API implementation needed",
        ResetPassword: "Reset Password",
        ResetPasswordConfirmTitle: "Reset Password?",
        ResetPasswordConfirmMessage: "Are you sure you want to reset the password for user '{0}'? A password reset email will be sent to their email address.",
        PasswordResetSuccess: "Password reset email sent successfully",
        PasswordResetError: "Failed to send password reset email",
        UserDetail: "User Detail",
        RelatedTo: "Related To",
        RelatedEntity: "Related Entity",
        CanViewAllEntries: "Can view all entries",
        CanViewAllEntriesHelperText: "When the user is linked to an employee, this allows them to see all employee entries instead of only their own.",
        Employee: "Employee",
        Client: "Client",
        NotLinked: "Not linked",
        OpenClientDetail: "Open Client Detail",
        OpenEmployeeDetail: "Open Employee Detail",
        UnlinkRelation: "Unlink Relation",
        UnlinkRelationConfirmTitle: "Unlink user relation?",
        UnlinkRelationConfirmMessage: "Are you sure you want to unlink user \"{userName}\" from the related client/employee profile?",
        UnlinkRelationSuccess: "User relation unlinked successfully",
        UnlinkRelationError: "Failed to unlink user relation",
    },
    profile: {
        ViewProfile: "View Profile",
        EditProfile: "Edit Profile",
        MyProfile: "My Profile",
        ChangePassword: "Change Password",
        MySchedule: "My Schedule",
        MyAbsences: "My Absences",
        MyBookings: "My Bookings",
        Username: "Username",
        Email: "Email",
        Phone: "Phone",
        FirstName: "First Name",
        LastName: "Last Name",
        CurrentPassword: "Current Password",
        NewPassword: "New Password",
        ConfirmPassword: "Confirm Password",
        PasswordHint: "Minimum 8 characters",
        UpdateSuccess: "Profile updated successfully",
        UpdateError: "Failed to update profile",
        LoadError: "Failed to load profile",
        PasswordChangeSuccess: "Password changed successfully",
        PasswordChangeError: "Failed to change password"
    },
    validation: {
        Required: "This field is required",
        InvalidEmail: "Invalid email address",
        PasswordTooShort: "Password must be at least 8 characters",
        PasswordMismatch: "Passwords do not match"
    },
    role: {
        RoleManagement: "Role Management",
        Roles: "Roles",
        Role: "Role",
        RoleName: "Role Name",
        RoleCode: "Role Code",
        Privileges: "Privileges",
        PrivilegeCount: "Privilege Count",
        CreateRole: "Create Role",
        EditRole: "Edit Role",
        DeleteRole: "Delete Role",
        SearchByRoleName: "Search by role name",
        SelectPrivileges: "Select privileges",
        RoleNameRequired: "Role name is required",
        RoleCodeRequired: "Role code is required",
        RoleSavedSuccessfully: "Role saved successfully",
        RoleDeletedSuccessfully: "Role deleted successfully",
        ErrorLoadingRoles: "Error loading roles",
        ErrorSavingRole: "Error saving role",
        ErrorDeletingRole: "Error deleting role",
        CannotDeleteSystemRole: "Cannot delete system role",
        CannotDeleteRoleWithUsers: "Cannot delete role that has assigned users",
        ComingSoon: "Role management coming soon - API implementation needed"
    },
    security: {
        ActiveSessions: "Active Sessions",
        Session: "Session",
        NoActiveSessions: "No active sessions found",
        IpAddress: "IP Address",
        UserAgent: "User Agent",
        CreatedOn: "Created On",
        LastAccessed: "Last Accessed",
        ExpiresAt: "Expires At",
        InvalidateSession: "Sign Out",
        ConfirmInvalidateSession: "Are you sure you want to sign out this session?",
        SessionInvalidated: "Session signed out successfully",
        FailedToLoadSessions: "Failed to load sessions",
        FailedToInvalidateSession: "Failed to sign out session",
        LoginAttempts: "Login Attempts",
        NoLoginAttempts: "No login attempts found",
        FailedToLoadAttempts: "Failed to load login attempts",
        Successful: "Successful",
        Failed: "Failed",
        FailureReason: "Reason",
        AttemptedAt: "Attempted At"
    },
    clientInvitation: {
        CompleteRegistration: "Complete Registration",
        CompleteRegistrationDescription: "Create your password to complete your account setup",
        Password: "Password",
        ConfirmPassword: "Confirm Password",
        EnterPassword: "Enter your password",
        EnterConfirmPassword: "Re-enter your password",
        PasswordHint: "Password must be at least 8 characters",
        PasswordTooShort: "Password must be at least 8 characters",
        PasswordMismatch: "Passwords do not match",
        InvitationExpires: "This invitation expires on",
        InvalidInvitationLink: "Invalid invitation link",
        InvitationInvalidOrExpired: "This invitation is invalid or has expired",
        InvitationExpired: "This invitation has expired",
        InvitationAlreadyUsed: "This invitation has already been used",
        FailedToLoadInvitation: "Failed to load invitation details",
        RegistrationCompleteSuccess: "Registration completed successfully! Redirecting to login...",
        RegistrationFailed: "Registration failed. Please try again.",
        EmailAlreadyRegistered: "This email address is already registered",
        SendInvitation: "Send Invitation",
        InvitationPrompt: "This client does not have a user account yet. Send an invitation to create one.",
        ResendInvitation: "Resend Invitation",
        InvitationSent: "Invitation sent successfully",
        InvitationResent: "Invitation resent successfully",
        FailedToSendInvitation: "Failed to send invitation",
        ConfirmSendInvitation: "Send registration invitation to this client?",
        ConfirmResendInvitation: "Resend registration invitation to this client?",
        ClientHasNoEmail: "Client must have an email address to receive an invitation",
        ClientAlreadyHasAccount: "Client already has a user account",
        BackToLogin: "Back to Login"
    },
    employeeInvitation: {
        SendInvitation: "Send Invitation",
        InvitationPrompt: "This employee does not have a user account yet. Send an invitation to create one.",
        InvitationSent: "Invitation sent successfully",
        FailedToSendInvitation: "Failed to send invitation",
        ConfirmSendInvitation: "Send registration invitation to this employee?",
        EmployeeHasNoEmail: "Employee must have an email address to receive an invitation"
    },
    public: {
        WelcomeToRuumi: "Welcome to Akersoni teenused",
        SelectServiceToBook: "Select a service to book your therapy session",
        SelectServiceCategoryToBook: "Select a service category to book your therapy session",
        BookNow: "Book Now",
        NoServicesAvailable: "No services available at this time",
        CheckingAvailability: "Checking availability...",
        SelectDate: "Select Date",
        SelectTimeSlot: "Select Time Slot",
        SelectTime: "Select Time",
        SelectParticipant: "Select participant",
        BookingFor: "Booking for",
        SelectParticipantPlaceholder: "Choose parent or child",
        SelectParticipantRequired: "Please select who the booking is for.",
        SelectClientType: "Select Client Type",
        SelectedService: "Selected Service",
        AvailableFor: "Available for",
        Available: "Available",
        YourInformation: "Your Information",
        ClientDetails: "Client Details",
        ProceedToPayment: "Proceed to Payment",
        PaymentMethod: "Payment Method",
        SelectPaymentMethod: "Select payment method",
        PaymentTermsHeading: "Payment Terms",
        TermsAgreementLabel: "I agree to the payment terms",
        TermsRequired: "Please accept the payment terms to continue.",
        ViewFullTerms: "View full terms",
        PayWithCard: "Pay with card",
        UseServicePass: "Use service pass",
        ServicePassAvailable: "Service pass available: {name} ({remaining} sessions remaining)",
        ServicePassUnavailable: "No active service pass available for this service.",
        CheckingServicePass: "Checking service pass...",
        ConfirmWithServicePass: "Confirm with service pass",
        ConfirmBooking: "Confirm booking",
        BookingFailed: "Booking failed. Please try again.",
        ServiceNotAvailable: "Service not available for this combination. Please try a different selection.",
        ValidatingPayment: "Validating payment...",
        PaymentSuccessful: "Payment Successful!",
        BookingConfirmed: "Your booking has been confirmed",
        BookingReference: "Booking Reference",
        PaymentStatus: "Payment Status",
        CheckYourEmail: "Check your email",
        EmailSentWithDetails: "We've sent you a confirmation email with all the details of your booking.",
        CreateAccount: "Create Account",
        BackToHome: "Back to Home",
        PaymentFailed: "Payment Failed",
        PaymentValidationError: "There was an error validating your payment. Please try again or contact support.",
        NoChargeApplied: "No charge has been applied to your account.",
        TryBookingAgain: "Try booking again",
        TryAgain: "Try Again",
        ContactSupport: "Contact Support",
        MissingOrderToken: "Missing order token in the URL. Unable to validate payment.",
        ValidationRequestFailed: "Payment validation request failed. Please check your internet connection and try again.",
        PaymentInitiationFailed: "Failed to initiate payment. Please try again.",
        NoTimeSlotsAvailable: "No time slots available for the selected date. Please choose a different date.",
        PersonalId: "Personal ID Code",
        DateOfBirth: "Date of Birth",
        ClientType: "Client Type",
        NoteToTherapist: "Note to Therapist (optional)",
        PersonalIdPlaceholder: "Enter Estonian personal code",
        DateOfBirthPlaceholder: "Select your date of birth",
        NotePlaceholder: "Any special notes or requirements..."
    }
};

export default enLocale;